export const defaultJson = [
  {
    "stepId": "profileDetails",
    "stepName": "Profile Details",
    "showStepName": false,
    "stepVisible": true,
    "stepPosition": 0,
    "stepType": "form",
    "sections": [
      {
        "apiKeyId": "application",
        "sectionId": "instructions",
        "sectionName": "Category Details",
        "subSectionName": "",
        "sectionPosition": 1,
        "sectionHelp": "Fields marked with * are required",
        "sectionType": "form",
        "fields": [
          {
            "fieldId": "application[Applicant_Type__c]",
            "required": true,
            "name": "application[Applicant_Type__c]",
            "label": "Type",
            "type": "select",
            "apiKey": "application[Applicant_Type__c]",
            "options": [
              {
                "label": "Domestic",
                "value": "Domestic"
              },
              {
                "label": "International",
                "value": "International"
              }
            ],
            "validations": {
              "required": "This field is required"
            },
            "ui": {
              "grid": {
                "xs": 12,
                "md": 6,
                "lg": 4
              }
            }
          },
          {
            "fieldId": "application[Category__c]",
            "required": true,
            "name": "application[Category__c]",
            "label": "Category",
            "type": "select",
            "metaData": {
              "optionsKey": "Domestic"
            },
            "options": [],
            "validations": {
              "required": "This field is required"
            },
            "ui": {
              "grid": {
                "xs": 12,
                "md": 6,
                "lg": 4
              }
            },
            "rule": {
              "effect": "SHOW",
              "condition": {
                "scope": "application[Applicant_Type__c]",
                "expectedValue": "Domestic",
                "type": "LEAF"
              }
            }
          },
          {
            "fieldId": "application[Category__c]",
            "required": true,
            "name": "application[Category__c]",
            "label": "Category",
            "type": "select",
            "metaData": {
              "optionsKey": "International"
            },
            "rule": {
              "effect": "SHOW",
              "condition": {
                "scope": "application[Applicant_Type__c]",
                "expectedValue": "International",
                "type": "LEAF"
              }
            },
            "options": [],
            "validations": {
              "required": "This field is required"
            },
            "ui": {
              "grid": {
                "xs": 12,
                "md": 6,
                "lg": 4
              }
            }
          },
          {
            "fieldId": "applicant[Passport_Number__c]",
            "required": true,
            "name": "applicant[Passport_Number__c]",
            "label": "Passport Number",
            "type": "string",
            "apiKey": "applicant[Passport_Number__c]",
            "validationType": "alphaNumeric",
            "validations": {
              "pattern": {
                "value": "",
                "message": "Please Enter a valid Passport Number"
              },
              "minLength": {
                "value": 6,
                "message": "This field cannot be less than 6 characters"
              },
              "maxLength": {
                "value": 15,
                "message": "This field cannot be more than 15 characters"
              },
              "required": "This field is required"
            },
            "rule": {
              "effect": "SHOW",
              "condition": {
                "scope": "application[Applicant_Type__c]",
                "expectedValue": "International",
                "type": "LEAF"
              }
            },
            "ui": {
              "grid": {
                "xs": 12,
                "md": 6,
                "lg": 4
              }
            }
          },
          {
            "fieldId": "applicant[Passport_place_of_issue__c]",
            "required": true,
            "name": "applicant[Passport_place_of_issue__c]",
            "label": "Passport Place Issue",
            "type": "input",
            "validationType": "passportPlace",
            "validations": {
              "required": "This field is required",
              "maxLength": {
                "value": 128,
                "message": "This field cannot be greater than 128 characters"
              },
              "pattern": {
                "value": "",
                "message": "Please enter a valid value"
              }
            },
            "rule": {
              "effect": "SHOW",
              "condition": {
                "scope": "application[Applicant_Type__c]",
                "expectedValue": "International",
                "type": "LEAF"
              }
            },
            "ui": {
              "grid": {
                "xs": 12,
                "md": 6,
                "lg": 4
              }
            }
          },
          {
            "fieldId": "applicant[Passport_Expiry_Date__c]",
            "required": true,
            "name": "applicant[Passport_Expiry_Date__c]",
            "label": "Passport Expiry Date",
            "type": "date",
            "apiKey": "applicant[Passport_Expiry_Date__c]",
            "minDate": 0.5,
            "format": "YYYY-MM-DD",
            "maxDate": 15,
            "validations": {
              "required": "This field is required"
            },
            "rule": {
              "effect": "SHOW",
              "condition": {
                "scope": "application[Applicant_Type__c]",
                "expectedValue": "International",
                "type": "LEAF"
              }
            },
            ui: {
              grid: {
                xs: 12,
                md: 6,
                lg: 4,
              },
            },
          },
        ],
      },
    ],
  },
  {
    "stepId": "basicInfo",
    "stepName": "Personal Details",
    "showStepName": false,
    "stepVisible": true,
    "stepPosition": 1,
    "stepType": "form",
    "sections": [
      {
        "sectionName": "Personal Details",
        "apiKeyId": "applicant",
        "subSectionName": "",
        "sectionPosition": 1,
        "sectionType": "form",
        "fields": [
          {
            "fieldId": "applicant[Salutation]",
            "name": "applicant[Salutation]",
            "label": "Salutation",
            "type": "select",
            "required": true,
            "options": [],
            "metaData": {
              "optionsKey": "saluation"
            },
            "validations": {
              "required": "This field is required"
            },
            "ui": {
              "grid": {
                "xs": 12,
                "md": 6,
                "lg": 4
              }
            }
          },
          {
            "fieldId": "applicant[FirstName]",
            "required": true,
            "name": "applicant[FirstName]",
            "label": "First Name",
            "type": "input",
            "validationType": "alphaWithSpace",
            "validations": {
              "required": "This field is required",
              "pattern": {
                "value": "",
                "message": "Please enter a valid First Name"
              },
              "maxLength": {
                "value": 100,
                "message": "This field cannot be more than 100 characters"
              }
            },
            "ui": {
              "grid": {
                "xs": 12,
                "md": 6,
                "lg": 4
              }
            }
          },
          {
            "fieldId": "applicant[LastName]",
            "required": true,
            "name": "applicant[LastName]",
            "label": "Last Name",
            "validationType": "lastName",
            "type": "input",
            "validations": {
              "required": "This field is required",
              "pattern": {
                "value": "",
                "message": "Please enter a valid Last Name"
              },
              "maxLength": {
                "value": 100,
                "message": "This field cannot be more than 100 characters"
              }
            },
            "ui": {
              "grid": {
                "xs": 12,
                "md": 6,
                "lg": 4
              }
            }
          },
          {
            "fieldId": "applicant[Preferred_Full_Name__c]",
            "required": true,
            "name": "applicant[Preferred_Full_Name__c]",
            "label": "Preferred Full Name",
            "helperLabel": "As per your official records",
            "type": "input",
            "validationType": "fullName",
            "validations": {
              "required": "This field is required",
              "pattern": {
                "value": "",
                "message": "Please enter a valid full name"
              },
              "maxLength": {
                "value": 255,
                "message": "This field cannot be more than 255 characters"
              }
            },
            "ui": {
              "grid": {
                "xs": 12,
                "md": 6,
                "lg": 4
              }
            }
          },
          {
            "fieldId": "applicant[hed__Gender__c]",
            "required": true,
            "name": "applicant[hed__Gender__c]",
            "label": "Gender",
            "type": "select",
            "validations": {
              "required": "This field is required"
            },
            "metaData": {
              "optionsKey": "gender"
            },
            "options": [],
            "ui": {
              "grid": {
                "xs": 12,
                "md": 6,
                "lg": 4
              }
            }
          },
          {
            "fieldId": "applicant[Phone]",
            "name": "applicant[Phone]",
            "label": "Mobile Number",
            "type": "phone",
            "required": true,
            "disabled": true,
            "ui": {
              "grid": {
                "xs": 12,
                "md": 6,
                "lg": 4
              }
            }
          },
          {
            "fieldId": "applicant[Email]",
            "required": true,
            "name": "applicant[Email]",
            "label": "Email",
            "type": "input",
            "disabled": true,
            "ui": {
              "grid": {
                "xs": 12,
                "md": 6,
                "lg": 4
              }
            }
          },
          {
            "fieldId": "applicant[Alternate_Mobile_Number__c]",
            "name": "applicant[Alternate_Mobile_Number__c]",
            "label": "Alternate Mobile Number",
            "type": "phone",
            "validateField": {
              "rule": "PHONEDUPLICATE",
              "scope": "applicant[Phone]"
            },
            "ui": {
              "grid": {
                "xs": 12,
                "md": 6,
                "lg": 4
              }
            }
          },
          {
            "fieldId": "applicant[hed__AlternateEmail__c]",
            "name": "applicant[hed__AlternateEmail__c]",
            "label": "Alternate Email",
            "type": "input",
            "validationType": "email",
            "validateField": {
              "rule": "EMAILDUPLICATE",
              "scope": "applicant[Email]"
            },
            "validations": {
              "pattern": {
                "value": "",
                "message": "Please enter a valid Email"
              }
            },
            "ui": {
              "grid": {
                "xs": 12,
                "md": 6,
                "lg": 4
              }
            }
          },
          {
            "fieldId": "applicant[Birthdate]",
            "required": true,
            "name": "applicant[Birthdate]",
            "label": "Date of Birth",
            "type": "date",
            "format": "YYYY-MM-DD",
            "validations": {
              "required": "This field is required"
            },
            "disableKeyDown": true,
            "minDate": 55,
            "maxDate": -15,
            "ui": {
              "grid": {
                "xs": 12,
                "md": 6,
                "lg": 4
              }
            }
          },
          {
            "fieldId": "applicant[hed__Citizenship__c]",
            "required": true,
            "name": "applicant[hed__Citizenship__c]",
            "label": "Citizenship",
            "type": "select",
            "metaData": {
              "optionsKey": "nationality"
            },
            "options": [],
            "validations": {
              "required": "This field is required"
            },
            ui: {
              grid: {
                xs: 12,
                md: 6,
                lg: 4,
              },
            },
          },
          {
            "fieldId": "applicant[Differently_Abled_Person_DAP__c]",
            "required": true,
            "name": "applicant[Differently_Abled_Person_DAP__c]",
            "label": "Are you a differently abled person (DAP) ?",
            "type": "radio",
            "options": [
              {
                "label": "Yes",
                "value": true
              },
              {
                "label": "No",
                "value": false
              }
            ],
            "validations": {
              "required": "This field is required"
            },
            "ui": {
              "grid": {
                "xs": 12,
                "md": 6,
                "lg": 4
              }
            }
          },
          {
            "fieldId": "applicant[DAP_Sub_category__c]",
            "required": true,
            "name": "applicant[DAP_Sub_category__c]",
            "label": "DAP Sub-category",
            "type": "select",
            "metaData": {
              "optionsKey": "subDap"
            },
            "options": [],
            "validations": {
              "required": "This field is required"
            },
            "rule": {
              "effect": "SHOW",
              "condition": {
                "scope": "applicant[Differently_Abled_Person_DAP__c]",
                "expectedValue": "true",
                "type": "LEAF"
              }
            },
            ui: {
              grid: {
                xs: 12,
                md: 6,
                lg: 4,
              },
            },
          },
        ],
      },
      {
        "sectionName": "Correspondence Address",
        "subSectionName": "",
        "sectionType": "form",
        "fields": [
          {
            "name": "addresses[0]",
            "type": "address",
            "options": [
              {
                "fieldId": "hed__MailingCountry__c",
                "required": true,
                "name": "hed__MailingCountry__c",
                "isPartOfCollection": true,
                "label": "Country",
                "type": "select",
                "validations": {
                  "required": "This field is required"
                },
                "ui": {
                  "grid": {
                    "xs": 12,
                    "md": 6,
                    "lg": 4
                  }
                }
              },
              {
                "fieldId": "hed__MailingState__c",
                "required": true,
                "name": "hed__MailingState__c",
                "label": "State",
                "type": "select",
                "validations": {
                  "required": "This field is required"
                },
                "options": [],
                "ui": {
                  "grid": {
                    "xs": 12,
                    "md": 6,
                    "lg": 4
                  }
                }
              },
              {
                "fieldId": "hed__MailingCity__c",
                "required": true,
                "name": "hed__MailingCity__c",
                "label": "City/Town",
                "type": "select",
                "validations": {
                  "required": "This field is required"
                },
                "options": [],
                "ui": {
                  "grid": {
                    "xs": 12,
                    "md": 6,
                    "lg": 4
                  }
                }
              }
            ]
          },
          {
            "fieldId": "addresses[0][Address_Line_1__c]",
            "required": true,
            "name": "addresses[0][Address_Line_1__c]",
            "label": "Address Line",
            "type": "input",
            "validations": {
              "required": "This field is required",
              "maxLength": {
                "value": 254,
                "message": "This field cannot be more than 254 characters"
              }
            },
            "ui": {
              "grid": {
                "xs": 12,
                "md": 6,
                "lg": 4
              }
            }
          },
          {
            "fieldId": "addresses[0][hed__MailingPostalCode__c]",
            "required": true,
            "name": "addresses[0][hed__MailingPostalCode__c]",
            "label": "Pincode/Zipcode",
            "type": "input",
            "validationType": "number",
            "helperText": "",
            "validations": {
              "required": "This field is required",
              "minLength": {
                "value": 6,
                "message": "Please enter a valid Zipcode"
              },
              "maxLength": {
                "value": 6,
                "message": "Please enter a valid Zipcode"
              },
              "pattern": {
                "value": "",
                "message": "Please enter a valid Zipcode"
              }
            },
            "rule": {
              "effect": "SHOW",
              "condition": {
                "scope": "addresses[0][hed__MailingCountry__c]",
                "expectedValue": "India",
                "type": "LEAF"
              }
            },
            "ui": {
              "grid": {
                "xs": 12,
                "md": 6,
                "lg": 4
              }
            }
          },
          {
            "fieldId": "addresses[0][hed__MailingPostalCode__c]",
            "required": true,
            "name": "addresses[0][hed__MailingPostalCode__c]",
            "label": "Pincode/Zipcode",
            "type": "input",
            "validationType": "pincode",
            "helperText": "",
            "validations": {
              "required": "This field is required",
              "minLength": {
                "value": 4,
                "message": "This field cannot be less than 4 characters"
              },
              "maxLength": {
                "value": 10,
                "message": "This field cannot be more than 10 characters"
              },
              "pattern": {
                "value": "",
                "message": "Please enter a valid Zipcode"
              }
            },
            "rule": {
              "effect": "HIDE",
              "condition": {
                "scope": "addresses[0][hed__MailingCountry__c]",
                "expectedValue": "India",
                "type": "LEAF"
              }
            },
            "ui": {
              "grid": {
                "xs": 12,
                "md": 6,
                "lg": 4
              }
            }
          }
        ]
      },
      {
        "sectionName": "Permanent Address",
        "subSectionName": "",
        "sectionType": "form",
        "fields": [
          {
            "fieldId": "addresses[0][Is_permanent_address_same_as_current_add__c]",
            "required": true,
            "name": "addresses[0][Is_permanent_address_same_as_current_add__c]",
            "label": "Is your current address same as permanent address?",
            "type": "radio",
            "options": [
              {
                "label": "Yes",
                "value": true
              },
              {
                "label": "No",
                "value": false
              }
            ],
            "validations": {
              "required": "This field is required"
            },
            "ui": {
              "grid": {
                "xs": 12,
                "md": 12,
                "lg": 12
              }
            }
          },
          {
            "name": "addresses[1]",
            "type": "address",
            "rule": {
              "effect": "SHOW",
              "condition": {
                "scope": "addresses[0][Is_permanent_address_same_as_current_add__c]",
                "expectedValue": "false",
                "type": "LEAF"
              }
            },
            "options": [
              {
                "fieldId": "hed__MailingCountry__c",
                "required": true,
                "name": "hed__MailingCountry__c",
                "isPartOfCollection": true,
                "label": "Country",
                "type": "select",
                "validations": {
                  "required": "This field is required"
                },
                "ui": {
                  "grid": {
                    "xs": 12,
                    "md": 6,
                    "lg": 4
                  }
                }
              },
              {
                "fieldId": "hed__MailingState__c",
                "required": true,
                "name": "hed__MailingState__c",
                "label": "State",
                "type": "select",
                "validations": {
                  "required": "This field is required"
                },
                "options": [],
                "ui": {
                  "grid": {
                    "xs": 12,
                    "md": 6,
                    "lg": 4
                  }
                }
              },
              {
                "fieldId": "hed__MailingCity__c",
                "required": true,
                "name": "hed__MailingCity__c",
                "label": "City/Town",
                "type": "select",
                "validations": {
                  "required": "This field is required"
                },
                "options": [],
                "ui": {
                  "grid": {
                    "xs": 12,
                    "md": 6,
                    "lg": 4
                  }
                }
              }
            ]
          },
          {
            "fieldId": "addresses[1][Address_Line_1__c]",
            "required": true,
            "name": "addresses[1][Address_Line_1__c]",
            "label": "Address Line",
            "type": "input",
            "validations": {
              "required": "This field is required",
              "maxLength": {
                "value": 254,
                "message": "This field cannot be more than 254 characters"
              }
            },
            "ui": {
              "grid": {
                "xs": 12,
                "md": 6,
                "lg": 4
              }
            },
            "rule": {
              "effect": "SHOW",
              "showInSummary": true,
              "condition": {
                "scope": "addresses[0][Is_permanent_address_same_as_current_add__c]",
                "expectedValue": "false",
                "type": "LEAF"
              }
            }
          },
          {
            "fieldId": "addresses[1][hed__MailingPostalCode__c]",
            "required": true,
            "name": "addresses[1][hed__MailingPostalCode__c]",
            "label": "Pincode/Zipcode",
            "type": "input",
            "validationType": "pincode",
            "validations": {
              "required": "This field is required",
              "minLength": {
                "value": 4,
                "message": "This field cannot be less than 4 characters"
              },
              "maxLength": {
                "value": 10,
                "message": "This field cannot be more than 10 characters"
              },
              "pattern": {
                "value": "",
                "message": "Please enter a valid Zipcode"
              }
            },
            "ui": {
              "grid": {
                "xs": 12,
                "md": 6,
                "lg": 4
              }
            },
            "rule": {
              "effect": "SHOW",
              "showInSummary": true,
              "condition": {
                "scope": "addresses[0][Is_permanent_address_same_as_current_add__c]",
                "expectedValue": "false",
                "type": "LEAF"
              }
            }
          }
        ]
      }
    ]
  },
  {
    stepId: 'workExperience',
    stepName: 'Work Experience',
    showStepName: false,
    stepVisible: true,
    stepPosition: 1,
    stepType: 'form',
    sections: [
      {
        sectionId: 'employmentDetails',
        sectionName: 'Work Experience',
        subSectionName: '',
        sectionPosition: 3,
        summarySection: 'Work Experience',
        sectionType: 'form',
        fields: [
          {
            fieldId: 'application[Do_you_have_any_work_experience__c]',
            required: true,
            name: 'application[Do_you_have_any_work_experience__c]',
            label: 'Do you have any work experience ?',
            type: 'radio',
            options: [
              {
                label: 'Yes',
                value: true,
              },
              {
                label: 'No',
                value: false,
              },
            ],
            validations: {
              required: 'This field is required',
            },
            ui: {
              grid: {
                xs: 12,
                md: 12,
                lg: 12,
              },
            },
          },
          {
            fieldId: 'workExperiences',
            name: 'workExperiences',
            label: 'Work Experiences',
            type: 'array',
            buttonConfigs: {
              text: 'Add Details +',
            },
            rule: {
              effect: 'SHOW',
              condition: {
                scope: 'application[Do_you_have_any_work_experience__c]',
                expectedValue: 'true',
                type: 'LEAF',
              },
            },
            metaData: {
              addMultiple: true,
              minItems: 1,
              maxLimit: 10,
              removeMultiple: false,
              name: 'workExperiences',
              dynamicTitle: 'Work Experience',
            },
            fieldsArray: [
              {
                fieldId: 'Organisation_Name__c',
                name: 'Organisation_Name__c',
                label: 'Organization Name',
                type: 'text',
                required: true,
                validationType: 'organization',
                validations: {
                  required: 'This field is required',
                  pattern: {
                    value: '',
                    message: 'Please enter a valid organization name',
                  },
                  maxLength: {
                    value: 128,
                    message: 'This field cannot be greater than 128 characters',
                  },
                },
                ui: {
                  grid: {
                    xs: 12,
                    md: 6,
                    lg: 4,
                  },
                },
              },
              {
                fieldId: 'Organisation_Type__c',
                name: 'Organisation_Type__c',
                label: 'Organization Type',
                type: 'select',
                required: true,
                metaData: {
                  optionsKey: 'organizationType',
                },
                options: [],
                validations: {
                  required: 'This field is required',
                },
                ui: {
                  grid: {
                    xs: 12,
                    md: 6,
                    lg: 4,
                  },
                },
              },
              {
                fieldId: 'Organisation_Type_Others__c',
                name: 'Organisation_Type_Others__c',
                label: 'Organization Type Other',
                type: 'text',
                required: true,
                validations: {
                  required: 'This field is required',
                  maxLength: {
                    value: 200,
                    message: 'This field cannot be more than 200 characters',
                  },
                },
                rule: {
                  effect: 'SHOW',
                  condition: {
                    scope: 'Organisation_Type__c',
                    expectedValue: 'Others',
                    type: 'LEAF',
                  },
                },
                ui: {
                  grid: {
                    xs: 12,
                    md: 6,
                    lg: 4,
                  },
                },
              },
              {
                fieldId: 'Industry_Type__c',
                name: 'Industry_Type__c',
                label: 'Industry Type',
                type: 'select',
                required: true,
                options: [],
                metaData: {
                  optionsKey: 'industryType',
                },
                validations: {
                  required: 'This field is required',
                },
                ui: {
                  grid: {
                    xs: 12,
                    md: 6,
                    lg: 4,
                  },
                },
              },
              {
                fieldId: 'Industry_Type_Others__c',
                name: 'Industry_Type_Others__c',
                label: 'Industry Type Others',
                type: 'input',
                required: true,
                options: [],
                validations: {
                  required: 'This field is required',
                  maxLength: {
                    value: 100,
                    message: 'This field cannot be more than 100 characters',
                  },
                },
                rule: {
                  effect: 'SHOW',
                  condition: {
                    scope: 'Industry_Type__c',
                    expectedValue: 'Others',
                    type: 'LEAF',
                  },
                },
                ui: {
                  grid: {
                    xs: 12,
                    md: 6,
                    lg: 4,
                  },
                },
              },
              {
                fieldId: 'Designation__c',
                name: 'Designation__c',
                label: 'Designation',
                type: 'input',
                required: true,
                validations: {
                  required: 'This field is required',
                  maxLength: {
                    value: 128,
                    message: 'This field cannot be more than 128 characters',
                  },
                },
                ui: {
                  grid: {
                    xs: 12,
                    md: 6,
                    lg: 4,
                  },
                },
              },
              {
                fieldId: 'Start_Date__c',
                name: 'Start_Date__c',
                label: 'Date Of Joining',
                type: 'date',
                format: 'YYYY-MM-DD',
                required: true,
                validations: {
                  required: 'This field is required',
                },
                minDate: {
                  scope: 'applicant[Birthdate]',
                  constant: true,
                  add: {
                    value: 10,
                    unit: 'years',
                  },
                },
                maxDate: true,
                ui: {
                  grid: {
                    xs: 12,
                    md: 6,
                    lg: 4,
                  },
                },
              },
              {
                fieldId: 'Currently_employed__c',
                name: 'Currently_employed__c',
                label: 'Currently employed ?',
                type: 'radio',
                uniqueData: 'true',
                disabled: false,
                options: [
                  {
                    label: 'Yes',
                    value: true,
                  },
                  {
                    label: 'No',
                    value: false,
                  },
                ],
                required: true,
                validations: {
                  required: 'This field is required',
                },
                ui: {
                  grid: {
                    xs: 12,
                    md: 6,
                    lg: 4,
                  },
                },
              },
              {
                fieldId: 'End_Date_Set__c',
                name: 'End_Date_Set__c',
                label: 'Date Of Relieving',
                type: 'date',
                required: true,
                format: 'YYYY-MM-DD',
                minDate: {
                  scope: 'Start_Date__c',
                },
                metaData: {
                  value: 'current',
                },
                ui: {
                  grid: {
                    xs: 12,
                    md: 6,
                    lg: 4,
                  },
                },
                hide: true,
                rule: {
                  effect: 'SHOW',
                  unregister: true,
                  condition: {
                    scope: 'Currently_employed__c',
                    expectedValue: 'true',
                    type: 'LEAF',
                  },
                },
              },
              {
                fieldId: 'End_Date__c',
                name: 'End_Date__c',
                label: 'Date Of Relieving',
                type: 'date',
                required: true,
                format: 'YYYY-MM-DD',
                validations: {
                  required: 'This field is required',
                },
                minDate: {
                  scope: 'Start_Date__c',
                },
                maxDate: 1,
                ui: {
                  grid: {
                    xs: 12,
                    md: 6,
                    lg: 4,
                  },
                },
                rule: {
                  effect: 'SHOW',
                  condition: {
                    unregister: true,
                    scope: 'Currently_employed__c',
                    expectedValue: 'false',
                    type: 'LEAF',
                  },
                },
              },
              {
                fieldId: 'Total_months_of_experience_as_on_Date__c',
                name: 'Total_months_of_experience_as_on_Date__c',
                label: 'Total months of experience (in months)',
                type: 'input',
                format: 'YYYY-MM-DD',
                summaryOnly: true,
                disabled: true,
                formulas: {
                  type: 'date',
                  scopeFields: {
                    operator1: 'Start_Date__c',
                    operator2: 'End_Date__c',
                  },
                  operation: 'SUB',
                },
                ui: {
                  grid: {
                    xs: 12,
                    md: 6,
                    lg: 4,
                  },
                },
              },
              {
                fieldId: 'Remuneration_Currency__c',
                name: 'Remuneration_Currency__c',
                label: 'Renumeration Currency',
                type: 'select',
                required: true,
                validations: {
                  required: 'This field is required',
                },
                options: [],
                metaData: {
                  optionsKey: 'currency',
                },
                ui: {
                  grid: {
                    xs: 12,
                    md: 6,
                    lg: 4,
                  },
                },
              },
              {
                fieldId: 'Renumeration_Currency_Other__c',
                name: 'Renumeration_Currency_Other__c',
                label: 'Renumeration Currency Other',
                type: 'input',
                required: true,
                validationType: 'organization',
                validations: {
                  required: 'This field is required',
                  pattern: {
                    value: '',
                    message: 'Please enter a valid currency code',
                  },
                },
                rule: {
                  effect: 'SHOW',
                  condition: {
                    scope: 'Remuneration_Currency__c',
                    expectedValue: 'Others',
                    type: 'LEAF',
                  },
                },
                ui: {
                  grid: {
                    xs: 12,
                    md: 6,
                    lg: 4,
                  },
                },
              },
              {
                fieldId: 'Annual_Remuneration_in_CTC__c',
                name: 'Annual_Remuneration_in_CTC__c',
                label: 'Annual Renumeration',
                type: 'input',
                required: true,
                textFormat: 'currency',
                validations: {
                  required: 'This field is required',
                  pattern: {
                    value: '',
                    message: 'Please enter a valid CTC',
                  },
                  maxLength: {
                    value: 14,
                    message: 'This field cannot be more than 14 characters',
                  },
                },
                ui: {
                  grid: {
                    xs: 12,
                    md: 6,
                    lg: 4,
                  },
                },
              },
              {
                fieldId: 'International_Exposure__c',
                name: 'International_Exposure__c',
                label: 'Did/does it offer international exposure ?',
                type: 'radio',
                required: true,
                options: [
                  {
                    value: true,
                    label: 'Yes',
                  },
                  {
                    label: 'No',
                    value: false,
                  },
                ],
                validations: {
                  required: 'This field is required',
                },
                ui: {
                  grid: {
                    xs: 12,
                    md: 6,
                    lg: 4,
                  },
                },
              },
              {
                fieldId: 'Role_KRA__c',
                name: 'Role_KRA__c',
                label: 'Roles/KRA',
                type: 'input',
                required: true,
                multiline: true,
                rows: 4,
                remaining: true,
                maxCharacters: 500,
                validations: {
                  required: 'This field is required',
                  maxLength: {
                    value: 500,
                    message: 'This field cannot be more than 500 characters',
                  },
                },
                ui: {
                  gridType: 'fullRow',
                },
              },
            ],
          },
          {
            fieldId: 'application[Overall_work_Experience__c]',
            required: true,
            name: 'application[Overall_work_Experience__c]',
            label: 'Overall work experience (as per system logic)',
            type: 'input',
            validationType: 'number',
            summaryOnly: true,
            ui: {
              grid: {
                xs: 12,
                md: 6,
                lg: 4,
              },
            },
          },
        ],
      },
    ],
  },
  {
    "stepId": "academicDetails",
    "stepName": "Academic Details",
    "showStepName": false,
    "stepVisible": true,
    "stepPosition": 1,
    "stepType": "form",
    "sections": [
      {
        "sectionId": "educationHistories",
        "sectionName": "SSC / Class 10",
        "subSectionName": "",
        "summarySection": "SSC / Class 10",
        "sectionPosition": 5,
        "sectionType": "form",
        "fields": [
          {
            "fieldId": "educationHistories[0][hed__Educational_Institution_Name__c]",
            "required": true,
            "name": "educationHistories[0][hed__Educational_Institution_Name__c]",
            "label": "Institution Name",
            "type": "input",
            "validationType": "organization",
            "validations": {
              "required": "This field is required",
              "pattern": {
                "value": "",
                "message": "Please enter a institution name"
              },
              "maxLength": {
                "value": 255,
                "message": "This field cannot be more than 255 characters"
              }
            },
            "ui": {
              "grid": {
                "xs": 12,
                "md": 6,
                "lg": 4
              }
            }
          },
          {
            "fieldId": "educationHistories[0][Board__c]",
            "name": "educationHistories[0][Board__c]",
            "required": true,
            "label": "Board Name",
            "type": "select",
            "metaData": {
              "optionsKey": "board10"
            },
            "options": [],
            "validations": {
              "required": "This field is required"
            },
            "ui": {
              "grid": {
                "xs": 12,
                "md": 6,
                "lg": 4
              }
            }
          },
          {
            "fieldId": "educationHistories[0][Board_Others__c]",
            "name": "educationHistories[0][Board_Others__c]",
            "label": "Board Others",
            "type": "input",
            "required": true,
            "options": [],
            "validationType": "organization",
            "validations": {
              "required": "This field is required",
              "pattern": {
                "value": "",
                "message": "Please enter a valid board"
              },
              "maxLength": {
                "value": 80,
                "message": "This field cannot be more than 80 characters"
              }
            },
            "rule": {
              "effect": "SHOW",
              "condition": {
                "scope": "educationHistories[0][Board__c]",
                "expectedValue": "Others",
                "type": "LEAF"
              }
            },
            "ui": {
              "grid": {
                "xs": 12,
                "md": 6,
                "lg": 4
              }
            }
          },
          {
            fieldId: 'educationHistories[0][Year_of_Completion__c]',
            required: true,
            name: 'educationHistories[0][Year_of_Completion__c]',
            label: 'Year of completion',
            type: 'date',
            format: 'DD-MMM-YYYY',
            views: ['year', 'month', 'day'],
            maxDate: true,
            minDate: {
              scope: 'applicant[Birthdate]',
              constant: true,
              add: {
                value: 10,
                unit: 'years',
                startOf: 'years',
              },
            },
            "validations": {
              "required": "This field is required"
            },
            "ui": {
              "grid": {
                "xs": 12,
                "md": 6,
                "lg": 4
              }
            }
          },
          {
            "fieldId": "educationHistories[0][Evaluation_type__c]",
            "name": "educationHistories[0][Evaluation_type__c]",
            "required": true,
            "label": "Evaluation Type",
            "type": "radio",
            "options": [
              {
                "label": "CGPA/GPA",
                "value": "CGPA/GPA"
              },
              {
                "label": "Percentage",
                "value": "Percentage"
              }
            ],
            "validations": {
              "required": "This field is required"
            },
            "ui": {
              "grid": {
                "xs": 12,
                "md": 6,
                "lg": 4
              }
            }
          },
          {
            "fieldId": "educationHistories[0][Maximum_CGPA_GPA_Grade_Percentage_Points__c]",
            "required": true,
            "name": "educationHistories[0][Maximum_CGPA_GPA_Grade_Percentage_Points__c]",
            "label": "Maximum CGPA/GPA",
            "validationType": "number",
            "type": "input",
            "validateField": {
              "scope": "educationHistories[0][Obtained_CGPA_GPA_Grade_Percentage_Point__c]",
              "rule": "GREATER",
              "message": "This field cannot be Less than Obtained Marks"
            },
            "rule": {
              "effect": "SHOW",
              "condition": {
                "scope": "educationHistories[0][Evaluation_type__c]",
                "expectedValue": "CGPA/GPA",
                "type": "LEAF"
              }
            },
            "validations": {
              "required": "This field is required",
              "pattern": {
                "value": "",
                "message": "Please enter a valid CGPA/GPA (Only whole numbers)"
              },
              "min": {
                "value": 1,
                "message": "This field should not be lesser than 1"
              },
              "max": {
                "value": 10,
                "message": "This field should not be greater than 10"
              }
            },
            "ui": {
              "grid": {
                "xs": 12,
                "md": 6,
                "lg": 4
              }
            }
          },
          {
            fieldId: 'educationHistories[0][Maximum_CGPA_GPA_Grade_Percentage_Points__c_II]',
            required: true,
            name: 'educationHistories[0][Maximum_CGPA_GPA_Grade_Percentage_Points__c_II]',
            label: 'Maximum Marks',
            validationType: 'numberWithDecimal',
            type: 'input',
            validateField: {
              scope: 'educationHistories[0][Obtained_CGPA_GPA_Grade_Percentage_Point__c_II]',
              rule: 'GREATER',
              message: 'This field cannot be Less than Obtained Marks',
            },
            "rule": {
              "effect": "SHOW",
              "condition": {
                "scope": "educationHistories[0][Evaluation_type__c]",
                "expectedValue": "Percentage",
                "type": "LEAF"
              }
            },
            "validations": {
              "required": "This field is required",
              "pattern": {
                "value": "",
                "message": "Please enter a valid percentage (maximum 2 digits after the decimal)"
              },
              "min": {
                "value": 1,
                "message": "This field should not be lesser than 1"
              },
              "max": {
                "value": 1200,
                "message": "This field should not be greater than 1200"
              }
            },
            "ui": {
              "grid": {
                "xs": 12,
                "md": 6,
                "lg": 4
              }
            }
          },
          {
            "fieldId": "educationHistories[0][Obtained_CGPA_GPA_Grade_Percentage_Point__c]",
            "required": true,
            "name": "educationHistories[0][Obtained_CGPA_GPA_Grade_Percentage_Point__c]",
            "label": "Obtained CGPA/GPA",
            "validationType": "numberWithDecimal",
            "type": "input",
            "validateField": {
              "scope": "educationHistories[0][Maximum_CGPA_GPA_Grade_Percentage_Points__c]",
              "rule": "LESSER",
              "message": "This field cannot be more than Total Attainable Marks"
            },
            "rule": {
              "effect": "SHOW",
              "condition": {
                "scope": "educationHistories[0][Evaluation_type__c]",
                "expectedValue": "CGPA/GPA",
                "type": "LEAF"
              }
            },
            "validations": {
              "required": "This field is required",
              "pattern": {
                "value": "",
                "message": "Please enter a valid CGPA/GPA (maximum 2 digits after the decimal)"
              },
              "min": {
                "value": 1,
                "message": "This field should not be lesser than 1"
              },
              "max": {
                "value": 10,
                "message": "This field should not be greater than 10"
              }
            },
            "ui": {
              "grid": {
                "xs": 12,
                "md": 6,
                "lg": 4
              }
            }
          },
          {
            fieldId: 'educationHistories[0][Obtained_CGPA_GPA_Grade_Percentage_Point__c_II]',
            required: true,
            name: 'educationHistories[0][Obtained_CGPA_GPA_Grade_Percentage_Point__c_II]',
            label: 'Obtained Marks',
            validationType: 'numberWithDecimal',
            type: 'input',
            validateField: {
              scope: 'educationHistories[0][Maximum_CGPA_GPA_Grade_Percentage_Points__c_II]',
              rule: 'LESSER',
              message: 'This field cannot be more than Total Attainable Marks',
            },
            "rule": {
              "effect": "SHOW",
              "condition": {
                "scope": "educationHistories[0][Evaluation_type__c]",
                "expectedValue": "Percentage",
                "type": "LEAF"
              }
            },
            "validations": {
              "required": "This field is required",
              "pattern": {
                "value": "",
                "message": "Please enter a valid percentage (maximum 2 digits after the decimal)"
              },
              "min": {
                "value": 1,
                "message": "This field should not be lesser than 1"
              },
              "max": {
                "value": 1200,
                "message": "This field should not be greater than 1200"
              }
            },
            "ui": {
              "grid": {
                "xs": 12,
                "md": 6,
                "lg": 4
              }
            }
          },
          {
            "fieldId": "educationHistories[0][Procedure_to_convert_CGPA_to__c]",
            "required": true,
            "name": "educationHistories[0][Procedure_to_convert_CGPA_to__c]",
            "label": "Procedure to convert CGPA to %",
            "type": "input",
            "rule": {
              "effect": "SHOW",
              "condition": {
                "scope": "educationHistories[0][Evaluation_type__c]",
                "expectedValue": "CGPA/GPA",
                "type": "LEAF"
              }
            },
            "validations": {
              "required": "This field is required",
              "maxLength": {
                "value": 255,
                "message": "This field cannot be more than 255 characters"
              }
            },
            "ui": {
              "grid": {
                "xs": 12,
                "md": 6,
                "lg": 4
              }
            }
          },
          {
            "fieldId": "educationHistories[0][Equivalent_Percentage__c]",
            "required": true,
            "name": "educationHistories[0][Equivalent_Percentage__c]",
            "label": "Equivalent Percentage",
            "type": "input",
            "rule": {
              "effect": "SHOW",
              "condition": {
                "scope": "educationHistories[0][Evaluation_type__c]",
                "expectedValue": "CGPA/GPA",
                "type": "LEAF"
              }
            },
            "validationType": "numberWithDecimal",
            "validations": {
              "required": "This field is required",
              "pattern": {
                "value": "",
                "message": "Please enter a valid percentage (maximum 2 digits after the decimal)"
              },
              "min": {
                "value": 1,
                "message": "This field should not be lesser than 1"
              },
              "max": {
                "value": 100,
                "message": "This field should not be greater than 100"
              }
            },
            "ui": {
              "grid": {
                "xs": 12,
                "md": 6,
                "lg": 4
              }
            }
          },
          {
            fieldId: 'educationHistories[0][Equivalent_Percentage__c_II]',
            required: true,
            name: 'educationHistories[0][Equivalent_Percentage__c_II]',
            label: 'Obtained Percentage',
            type: 'input',
            rule: {
              effect: 'SHOW',
              condition: {
                scope: 'educationHistories[0][Evaluation_type__c]',
                expectedValue: 'Percentage',
                type: 'LEAF',
              },
            },
            "validationType": "numberWithDecimal",
            "validations": {
              "required": "This field is required",
              "pattern": {
                "value": "",
                "message": "Please enter a valid percentage (maximum 2 digits after the decimal)"
              },
              "min": {
                "value": 1,
                "message": "This field should not be lesser than 1"
              },
              "max": {
                "value": 100,
                "message": "This field should not be greater than 100"
              }
            },
            "ui": {
              "grid": {
                "xs": 12,
                "md": 6,
                "lg": 4
              }
            }
          }
        ]
      },
      {
        "sectionId": "educationHistories[1]",
        "sectionName": "HSC / Class 12 or Diploma (University)",
        "subSectionName": "",
        "summarySection": "HSC / Class 12 or Diploma (University)",
        "sectionPosition": 5,
        "sectionType": "form",
        "fields": [
          {
            "fieldId": "educationHistories[1][Type__c]",
            "name": "educationHistories[1][Type__c]",
            "required": true,
            "label": "Type",
            "type": "select",
            "options": [
              {
                "label": "HSC",
                "value": "HSC"
              },
              {
                "label": "Diploma",
                "value": "Diploma"
              }
            ],
            "validations": {
              "required": "This field is required"
            },
            "ui": {
              "grid": {
                "xs": 12,
                "md": 6,
                "lg": 4
              }
            }
          },
          {
            "fieldId": "educationHistories[1][Discipline__c]",
            "name": "educationHistories[1][Discipline__c]",
            "required": true,
            "label": "Discipline",
            "type": "select",
            "metaData": {
              "optionsKey": "disciplineHsc"
            },
            "validations": {
              "required": "This field is required"
            },
            "rule": {
              "effect": "SHOW",
              "condition": {
                "scope": "educationHistories[1][Type__c]",
                "expectedValue": "HSC",
                "type": "LEAF"
              }
            },
            "ui": {
              "grid": {
                "xs": 12,
                "md": 6,
                "lg": 4
              }
            }
          },
          {
            fieldId: 'educationHistories[1][Discipline_Others__c]',
            name: 'educationHistories[1][Discipline_Others__c]',
            required: true,
            label: 'Discipline (Others)',
            type: 'text',
            validationType: 'alpha',
            validations: {
              required: 'This field is required',
              maxLength: {
                value: 64,
                message: 'This field cannot be greater than 64 characters',
              },
              "pattern": {
                "value": "",
                "message": "Please enter a valid discipline"
              }
            },
            "rule": {
              "effect": "SHOW",
              "condition": {
                "scope": [
                  "educationHistories[1][Discipline__c]",
                  "educationHistories[1][Type__c]"
                ],
                "every": true,
                "expectedValue": {
                  "educationHistories[1][Discipline__c]": "Others",
                  "educationHistories[1][Type__c]": "HSC"
                },
                "type": "LEAF"
              }
            },
            "ui": {
              "grid": {
                "xs": 12,
                "md": 6,
                "lg": 4
              }
            }
          },
          {
            "fieldId": "educationHistories[1][hed__Educational_Institution_Name__c]",
            "required": true,
            "name": "educationHistories[1][hed__Educational_Institution_Name__c]",
            "label": "University Name",
            "type": "input",
            "validationType": "organization",
            "validations": {
              "required": "This field is required",
              "pattern": {
                "value": "",
                "message": "Please enter a valid university name"
              },
              "maxLength": {
                "value": 80,
                "message": "This field cannot be more than 80 characters"
              }
            },
            "rule": {
              "effect": "SHOW",
              "condition": {
                "scope": "educationHistories[1][Type__c]",
                "expectedValue": "Diploma",
                "type": "LEAF"
              }
            },
            "ui": {
              "grid": {
                "xs": 12,
                "md": 6,
                "lg": 4
              }
            }
          },
          {
            "fieldId": "educationHistories[1][hed__Educational_Institution_Name__c]",
            "required": true,
            "name": "educationHistories[1][hed__Educational_Institution_Name__c]",
            "label": "Institution Name",
            "type": "input",
            "validationType": "organization",
            "validations": {
              "required": "This field is required",
              "pattern": {
                "value": "",
                "message": "Please enter a valid institution name"
              },
              "maxLength": {
                "value": 80,
                "message": "This field cannot be more than 80 characters"
              }
            },
            "rule": {
              "effect": "SHOW",
              "condition": {
                "scope": "educationHistories[1][Type__c]",
                "expectedValue": "HSC",
                "type": "LEAF"
              }
            },
            "ui": {
              "grid": {
                "xs": 12,
                "md": 6,
                "lg": 4
              }
            }
          },
          {
            "fieldId": "educationHistories[1][Board__c]",
            "name": "educationHistories[1][Board__c]",
            "required": true,
            "label": "Board Name",
            "type": "select",
            "metaData": {
              "optionsKey": "board12"
            },
            "options": [],
            "validations": {
              "required": "This field is required"
            },
            "ui": {
              "grid": {
                "xs": 12,
                "md": 6,
                "lg": 4
              }
            },
            "rule": {
              "effect": "SHOW",
              "condition": {
                "scope": "educationHistories[1][Type__c]",
                "expectedValue": "HSC",
                "type": "LEAF"
              }
            }
          },
          {
            "fieldId": "educationHistories[1][Board_Others__c]",
            "name": "educationHistories[1][Board_Others__c]",
            "label": "Board Others",
            "type": "input",
            "required": true,
            "validationType": "organization",
            "validations": {
              "required": "This field is required",
              "pattern": {
                "value": "",
                "message": "Please enter a valid board"
              },
              "maxLength": {
                "value": 80,
                "message": "This field cannot be more than 80 characters"
              }
            },
            "rule": {
              "effect": "SHOW",
              "condition": {
                "scope": [
                  "educationHistories[1][Type__c]",
                  "educationHistories[1][Board__c]"
                ],
                "expectedValue": {
                  "educationHistories[1][Type__c]": "HSC",
                  "educationHistories[1][Board__c]": "Others"
                },
                "every": true,
                "type": "LEAF"
              }
            },
            "ui": {
              "grid": {
                "xs": 12,
                "md": 6,
                "lg": 4
              }
            }
          },
          {
            fieldId: 'educationHistories[1][Year_of_Completion__c]',
            required: true,
            name: 'educationHistories[1][Year_of_Completion__c]',
            label: 'Year of completion',
            type: 'date',
            format: 'DD-MMM-YYYY',
            views: ['year', 'month', 'day'],
            maxDate: true,
            minDate: {
              scope: 'educationHistories[0][Year_of_Completion__c]',
              constant: true,
              add: {
                value: 2,
                unit: 'years',
                startOf: 'years',
              },
            },
            "validations": {
              "required": "This field is required"
            },
            "ui": {
              "grid": {
                "xs": 12,
                "md": 6,
                "lg": 4
              }
            }
          },
          {
            "fieldId": "educationHistories[1][Evaluation_type__c]",
            "name": "educationHistories[1][Evaluation_type__c]",
            "required": true,
            "label": "Evaluation Type",
            "type": "radio",
            "options": [
              {
                "label": "CGPA/GPA",
                "value": "CGPA/GPA"
              },
              {
                "label": "Percentage",
                "value": "Percentage"
              }
            ],
            "validations": {
              "required": "This field is required"
            },
            "ui": {
              "grid": {
                "xs": 12,
                "md": 6,
                "lg": 4
              }
            }
          },
          {
            "fieldId": "educationHistories[1][Maximum_CGPA_GPA_Grade_Percentage_Points__c]",
            "required": true,
            "name": "educationHistories[1][Maximum_CGPA_GPA_Grade_Percentage_Points__c]",
            "label": "Maximum CGPA/GPA",
            "validationType": "number",
            "type": "input",
            "validateField": {
              "scope": "educationHistories[1][Obtained_CGPA_GPA_Grade_Percentage_Point__c]",
              "rule": "GREATER",
              "message": "This field cannot be Less than Obtained Marks"
            },
            "rule": {
              "effect": "SHOW",
              "condition": {
                "scope": "educationHistories[1][Evaluation_type__c]",
                "expectedValue": "CGPA/GPA",
                "type": "LEAF"
              }
            },
            "validations": {
              "required": "This field is required",
              "pattern": {
                "value": "",
                "message": "Please enter a valid CGPA/GPA (Only whole numbers)"
              },
              "min": {
                "value": 1,
                "message": "This field should not be lesser than 1"
              },
              "max": {
                "value": 10,
                "message": "This field should not be greater than 10"
              }
            },
            "ui": {
              "grid": {
                "xs": 12,
                "md": 6,
                "lg": 4
              }
            }
          },
          {
            fieldId: 'educationHistories[1][Maximum_CGPA_GPA_Grade_Percentage_Points__c_II]',
            required: true,
            name: 'educationHistories[1][Maximum_CGPA_GPA_Grade_Percentage_Points__c_II]',
            label: 'Maximum Marks',
            validationType: 'numberWithDecimal',
            type: 'input',
            validateField: {
              scope: 'educationHistories[1][Obtained_CGPA_GPA_Grade_Percentage_Point__c_II]',
              rule: 'GREATER',
              message: 'This field cannot be Less than Obtained Marks',
            },
            "rule": {
              "effect": "SHOW",
              "condition": {
                "scope": "educationHistories[1][Evaluation_type__c]",
                "expectedValue": "Percentage",
                "type": "LEAF"
              }
            },
            "validations": {
              "required": "This field is required",
              "pattern": {
                "value": "",
                "message": "Please enter a valid percentage (maximum 2 digits after the decimal)"
              },
              "min": {
                "value": 1,
                "message": "This field should not be lesser than 1"
              },
              "max": {
                "value": 1200,
                "message": "This field should not be greater than 1200"
              }
            },
            "ui": {
              "grid": {
                "xs": 12,
                "md": 6,
                "lg": 4
              }
            }
          },
          {
            "fieldId": "educationHistories[1][Obtained_CGPA_GPA_Grade_Percentage_Point__c]",
            "required": true,
            "name": "educationHistories[1][Obtained_CGPA_GPA_Grade_Percentage_Point__c]",
            "label": "Obtained CGPA/GPA",
            "validationType": "numberWithDecimal",
            "type": "input",
            "validateField": {
              "scope": "educationHistories[1][Maximum_CGPA_GPA_Grade_Percentage_Points__c]",
              "rule": "LESSER",
              "message": "This field cannot be more than Total Attainable Marks"
            },
            "rule": {
              "effect": "SHOW",
              "condition": {
                "scope": "educationHistories[1][Evaluation_type__c]",
                "expectedValue": "CGPA/GPA",
                "type": "LEAF"
              }
            },
            "validations": {
              "required": "This field is required",
              "pattern": {
                "value": "",
                "message": "Please enter a valid CGPA/GPA (maximum 2 digits after the decimal)"
              },
              "min": {
                "value": 1,
                "message": "This field should not be lesser than 1"
              },
              "max": {
                "value": 10,
                "message": "This field should not be greater than 10"
              }
            },
            "ui": {
              "grid": {
                "xs": 12,
                "md": 6,
                "lg": 4
              }
            }
          },
          {
            fieldId: 'educationHistories[1][Obtained_CGPA_GPA_Grade_Percentage_Point__c_II]',
            required: true,
            name: 'educationHistories[1][Obtained_CGPA_GPA_Grade_Percentage_Point__c_II]',
            label: 'Obtained Marks',
            validationType: 'numberWithDecimal',
            type: 'input',
            validateField: {
              scope: 'educationHistories[1][Maximum_CGPA_GPA_Grade_Percentage_Points__c_II]',
              rule: 'LESSER',
              message: 'This field cannot be more than Total Attainable Marks',
            },
            "rule": {
              "effect": "SHOW",
              "condition": {
                "scope": "educationHistories[1][Evaluation_type__c]",
                "expectedValue": "Percentage",
                "type": "LEAF"
              }
            },
            "validations": {
              "required": "This field is required",
              "pattern": {
                "value": "",
                "message": "Please enter a valid percentage (maximum 2 digits after the decimal)"
              },
              "min": {
                "value": 1,
                "message": "This field should not be lesser than 1"
              },
              "max": {
                "value": 1200,
                "message": "This field should not be greater than 1200"
              }
            },
            "ui": {
              "grid": {
                "xs": 12,
                "md": 6,
                "lg": 4
              }
            }
          },
          {
            fieldId: 'educationHistories[1][Procedure_to_convert_CGPA_to__c]',
            required: true,
            name: 'educationHistories[1][Procedure_to_convert_CGPA_to__c]',
            label: 'Procedure to convert CGPA to %',
            type: 'input',
            rule: {
              effect: 'SHOW',
              condition: {
                scope: 'educationHistories[1][Evaluation_type__c]',
                expectedValue: 'CGPA/GPA',
                type: 'LEAF',
              },
            },
            validations: {
              required: 'This field is required',
              maxLength: {
                value: 255,
                message: 'This field cannot be more than 255 characters',
              },
            },
            "ui": {
              "grid": {
                "xs": 12,
                "md": 6,
                "lg": 4
              }
            }
          },
          {
            fieldId: 'educationHistories[1][Equivalent_Percentage__c]',
            required: true,
            name: 'educationHistories[1][Equivalent_Percentage__c]',
            label: 'Equivalent Percentage',
            type: 'input',
            rule: {
              effect: 'SHOW',
              condition: {
                scope: 'educationHistories[1][Evaluation_type__c]',
                expectedValue: 'CGPA/GPA',
                type: 'LEAF',
              },
            },
            validationType: 'numberWithDecimal',
            validations: {
              required: 'This field is required',
              pattern: {
                value: '',
                message: 'Please enter a valid percentage (maximum 2 digits after the decimal)',
              },
              min: {
                value: 1,
                message: 'This field should not be lesser than 1',
              },
              max: {
                value: 100,
                message: 'This field should not be greater than 100',
              },
            },
            "ui": {
              "grid": {
                "xs": 12,
                "md": 6,
                "lg": 4
              }
            }
          },
          {
            fieldId: 'educationHistories[1][Equivalent_Percentage__c_II]',
            required: true,
            name: 'educationHistories[1][Equivalent_Percentage__c_II]',
            label: 'Obtained Percentage',
            type: 'input',
            rule: {
              effect: 'SHOW',
              condition: {
                scope: 'educationHistories[1][Evaluation_type__c]',
                expectedValue: 'Percentage',
                type: 'LEAF',
              },
            },
            "validationType": "numberWithDecimal",
            "validations": {
              "required": "This field is required",
              "pattern": {
                "value": "",
                "message": "Please enter a valid percentage (maximum 2 digits after the decimal)"
              },
              "min": {
                "value": 1,
                "message": "This field should not be lesser than 1"
              },
              "max": {
                "value": 100,
                "message": "This field should not be greater than 100"
              }
            },
            "ui": {
              "grid": {
                "xs": 12,
                "md": 6,
                "lg": 4
              }
            }
          }
        ]
      },
      {
        "apiKeyId": "",
        "sectionName": "Bachelor's Degree",
        "sectionId": "educationHistoriesUg",
        "subSectionName": "",
        "summarySection": "Bachelor's Degree",
        "sectionPosition": 1,
        "sectionType": "form",
        "fields": [
          {
            "fieldId": "educationHistoriesUg",
            "name": "educationHistoriesUg",
            "label": "",
            "type": "array",
            "metaData": {
              "addMultiple": true,
              "minItems": 1,
              "maxLimit": 10,
              "name": "educationHistories",
              "removeMultiple": false,
              "dynamicTitle": "Degree"
            },
            defaultItemValue: {
              Degree_Name__c: '',
              Discipline__c: '',
              Discipline_Others__c: '',
              Specialization__c: '',
              Degree_Name_Other__c: '',
              hed__Educational_Institution_Name__c: '',
              University_Type__c: '',
              University_Others__c: '',
              Degree_Complete__c: '',
              Year_of_Completion__c: '',
              Evaluation_type__c: '',
              Obtained_CGPA_GPA_Grade_Percentage_Point__c: '',
              Maximum_CGPA_GPA_Grade_Percentage_Points__c: '',
              Class_or_Distinction__c: '',
              Procedure_to_convert_CGPA_to__c: '',
            },
            fieldsArray: [
              {
                "fieldId": "Degree_Name__c",
                "name": "Degree_Name__c",
                "label": "Degree Name",
                "type": "select",
                "metaData": {
                  "optionsKey": "ugDegree"
                },
                options: [],
                validations: {
                  required: 'This field is required',
                },
                ui: {
                  grid: {
                    xs: 12,
                    md: 6,
                    lg: 4,
                  },
                },
                required: true,
              },
              {
                fieldId: 'Degree_Name_Other__c',
                name: 'Degree_Name_Other__c',
                label: 'Degree Name Others',
                type: 'input',
                helperText: 'Only characters and space',
                validationType: 'alphaWithSpace',
                validations: {
                  required: 'This field is required',
                  pattern: {
                    value: '',
                    message: 'Please enter a valid degree name',
                  },
                },
                ui: {
                  grid: {
                    xs: 12,
                    md: 6,
                    lg: 4,
                  },
                },
                required: true,
                rule: {
                  effect: 'SHOW',
                  condition: {
                    scope: 'Degree_Name__c',
                    expectedValue: 'Others',
                    type: 'LEAF',
                  },
                },
              },
              {
                fieldId: 'Discipline__c',
                name: 'Discipline__c',
                required: true,
                label: 'Discipline',
                type: 'select',
                metaData: {
                  optionsKey: 'discipline',
                },
                options: [],
                validations: {
                  required: 'This field is required',
                },
                "ui": {
                  "grid": {
                    "xs": 12,
                    "md": 6,
                    "lg": 4
                  }
                }
              },
              {
                "fieldId": "Discipline_Others__c",
                "name": "Discipline_Others__c",
                "required": true,
                "label": "Discipline (Others)",
                "type": "input",
                "helperText": "Only characters and space",
                "validationType": "alphaWithSpace",
                "validations": {
                  "required": "This field is required",
                  "pattern": {
                    "value": "",
                    "message": "Please enter a valid degree name"
                  }
                },
                "ui": {
                  "grid": {
                    "xs": 12,
                    "md": 6,
                    "lg": 4
                  }
                },
                rule: {
                  effect: 'SHOW',
                  condition: {
                    scope: 'Discipline__c',
                    expectedValue: 'Others',
                    type: 'LEAF',
                  },
                },
              },
              {
                fieldId: 'Specialization__c',
                required: true,
                name: 'Specialization__c',
                label: 'Specialization',
                type: 'input',
                validationType: 'organization',
                validations: {
                  required: 'This field is required',
                  pattern: {
                    value: '',
                    message: 'Please enter a valid specialization',
                  },
                  "maxLength": {
                    "value": 64,
                    "message": "This field cannot be more than 64 characters"
                  }
                },
                "ui": {
                  "grid": {
                    "xs": 12,
                    "md": 6,
                    "lg": 4
                  }
                }
              },
              {
                fieldId: 'hed__Educational_Institution_Name__c',
                name: 'hed__Educational_Institution_Name__c',
                label: 'Institution Name',
                type: 'input',
                required: true,
                validationType: 'organization',
                validations: {
                  required: 'This field is required',
                  pattern: {
                    value: '',
                    message: 'Please enter a valid institution name',
                  },
                  "maxLength": {
                    "value": 255,
                    "message": "This field cannot be more than 255 characters"
                  }
                },
                "ui": {
                  "grid": {
                    "xs": 12,
                    "md": 6,
                    "lg": 4
                  }
                }
              },
              {
                fieldId: 'Duration_of_the_Program__c',
                name: 'Duration_of_the_Program__c',
                label: 'Duration of the program',
                type: 'select',
                required: true,
                metaData: {
                  optionsKey: 'durationOfTheProgramBachelor',
                },
                validations: {
                  required: 'This field is required',
                },
                ui: {
                  grid: {
                    xs: 12,
                    md: 6,
                    lg: 4,
                  },
                },
              },
              {
                fieldId: 'University_Type__c',
                name: 'University_Type__c',
                label: 'University Type',
                type: 'select',
                required: true,
                metaData: {
                  optionsKey: 'universityType',
                },
                options: [],
                validations: {
                  required: 'This field is required',
                },
                "ui": {
                  "grid": {
                    "xs": 12,
                    "md": 6,
                    "lg": 4
                  }
                }
              },
              {
                fieldId: 'University_Others__c',
                name: 'University_Others__c',
                label: 'University Type Others',
                type: 'text',
                required: true,
                rule: {
                  effect: 'SHOW',
                  condition: {
                    scope: 'University_Type__c',
                    expectedValue: 'Others',
                    type: 'LEAF',
                  },
                },
                validationType: 'organization',
                validations: {
                  required: 'This field is required',
                  pattern: {
                    value: '',
                    message: 'Please enter a valid university name',
                  },
                  "maxLength": {
                    "value": 256,
                    "message": "This field cannot be greater than 256 characters"
                  }
                },
                "ui": {
                  "grid": {
                    "xs": 12,
                    "md": 6,
                    "lg": 4
                  }
                }
              },
              {
                fieldId: 'Degree_Complete__c',
                required: true,
                name: 'Degree_Complete__c',
                label: 'Degree Complete ?',
                type: 'radio',
                options: [
                  {
                    "label": "Yes",
                    "value": true
                  },
                  {
                    "label": "No",
                    "value": false
                  }
                ],
                validations: {
                  required: 'This field is required',
                },
                "ui": {
                  "grid": {
                    "xs": 12,
                    "md": 6,
                    "lg": 4
                  }
                }
              },
              {
                fieldId: 'Year_of_Completion__c',
                name: 'Year_of_Completion__c',
                label: 'Year of completion (Awaited)',
                type: 'date',
                format: 'DD-MMM-YYYY',
                views: ['year', 'month', 'day'],
                maxDate: 1,
                minDate: true,
                validations: {
                  required: 'This field is required',
                },
                "rule": {
                  "effect": "SHOW",
                  "condition": {
                    "scope": "Degree_Complete__c",
                    "expectedValue": "false",
                    "type": "LEAF"
                  }
                },
                "required": true,
                "ui": {
                  "grid": {
                    "xs": 12,
                    "md": 6,
                    "lg": 4
                  }
                }
              },
              {
                fieldId: 'Year_of_Completion__c',
                name: 'Year_of_Completion__c',
                label: 'Year of completion',
                type: 'date',
                format: 'DD-MMM-YYYY',
                views: ['year', 'month', 'day'],
                maxDate: true,
                minDate: {
                  scope: 'educationHistories.1.Year_of_Completion__c',
                  constant: true,
                  add: {
                    value: 3,
                    unit: 'years',
                    startOf: 'years',
                  },
                },
                "validations": {
                  "required": "This field is required"
                },
                "rule": {
                  "effect": "SHOW",
                  "condition": {
                    "scope": "Degree_Complete__c",
                    "expectedValue": "true",
                    "type": "LEAF"
                  }
                },
                "required": true,
                "ui": {
                  "grid": {
                    "xs": 12,
                    "md": 6,
                    "lg": 4
                  }
                }
              },
              {
                "fieldId": "Evaluation_type__c",
                "name": "Evaluation_type__c",
                "required": true,
                "label": "Evaluation Type",
                "type": "radio",
                "options": [
                  {
                    "label": "CGPA/GPA",
                    "value": "CGPA/GPA"
                  },
                  {
                    "label": "Percentage",
                    "value": "Percentage"
                  }
                ],
                "validations": {
                  "required": "This field is required"
                },
                "rule": {
                  "effect": "SHOW",
                  "condition": {
                    "scope": "Degree_Complete__c",
                    "expectedValue": "true",
                    "type": "LEAF"
                  }
                },
                "ui": {
                  "grid": {
                    "xs": 12,
                    "md": 6,
                    "lg": 4
                  }
                }
              },
              {
                fieldId: 'Obtained_CGPA_GPA_Grade_Percentage_Point__c',
                required: true,
                name: 'Obtained_CGPA_GPA_Grade_Percentage_Point__c',
                label: 'Obtained Marks (CGPA/GPA)',
                validationType: 'numberWithDecimal',
                type: 'input',
                validateField: {
                  scope: 'Maximum_CGPA_GPA_Grade_Percentage_Points__c',
                  rule: 'LESSER',
                  message: 'This field cannot be more than Total Attainable Marks',
                },
                validations: {
                  required: 'This field is required',
                  pattern: {
                    value: '',
                    message: 'Please enter a valid CGPA/GPA (maximum 2 digits after the decimal)',
                  },
                  min: {
                    value: 1,
                    message: 'This field should not be lesser than 1',
                  },
                  max: {
                    value: 10,
                    message: 'This field should not be greater than 10',
                  },
                },
                rule: {
                  effect: 'SHOW',
                  condition: {
                    scope: ['Degree_Complete__c', 'Evaluation_type__c'],
                    expectedValue: {
                      Degree_Complete__c: 'true',
                      Evaluation_type__c: 'CGPA/GPA',
                    },
                    every: true,
                    type: 'LEAF',
                  },
                },
                ui: {
                  grid: {
                    xs: 12,
                    md: 6,
                    lg: 4,
                  },
                },
              },
              {
                "fieldId": "Maximum_CGPA_GPA_Grade_Percentage_Points__c",
                "required": true,
                "name": "Maximum_CGPA_GPA_Grade_Percentage_Points__c",
                "label": "Maximum CGPA/GPA",
                "validationType": "number",
                "type": "input",
                "validateField": {
                  "scope": "Obtained_CGPA_GPA_Grade_Percentage_Point__c",
                  "rule": "GREATER",
                  "message": "This field cannot be more than Total Attainable Marks"
                },
                "rule": {
                  "effect": "SHOW",
                  "condition": {
                    "scope": [
                      "Degree_Complete__c",
                      "Evaluation_type__c"
                    ],
                    "expectedValue": {
                      "Degree_Complete__c": "true",
                      "Evaluation_type__c": "CGPA/GPA"
                    },
                    "every": true,
                    "type": "LEAF"
                  }
                },
                "validations": {
                  "required": "This field is required",
                  "pattern": {
                    "value": "",
                    "message": "Please enter a valid CGPA/GPA (Only whole numbers)"
                  },
                  "min": {
                    "value": 1,
                    "message": "This field should not be lesser than 1"
                  },
                  "max": {
                    "value": 10,
                    "message": "This field should not be greater than 10"
                  }
                },
                "ui": {
                  "grid": {
                    "xs": 12,
                    "md": 6,
                    "lg": 4
                  }
                }
              },
              {
                fieldId: 'Obtained_CGPA_GPA_Grade_Percentage_Point__c',
                required: true,
                name: 'Obtained_CGPA_GPA_Grade_Percentage_Point__c',
                label: 'Obtained Marks (CGPA/GPA)',
                validationType: 'numberWithDecimal',
                type: 'input',
                validateField: {
                  scope: 'Maximum_CGPA_GPA_Grade_Percentage_Points__c',
                  rule: 'LESSER',
                  message: 'This field cannot be more than Total Attainable Marks',
                },
                validations: {
                  required: 'This field is required',
                  pattern: {
                    value: '',
                    message: 'Please enter a valid CGPA/GPA (maximum 2 digits after the decimal)',
                  },
                  "min": {
                    "value": 1,
                    "message": "This field should not be lesser than 1"
                  },
                  max: {
                    value: 10,
                    message: 'This field should not be greater than 10',
                  },
                },
                rule: {
                  effect: 'SHOW',
                  condition: {
                    scope: ['Degree_Complete__c', 'Evaluation_type__c'],
                    expectedValue: {
                      Degree_Complete__c: 'true',
                      Evaluation_type__c: 'CGPA/GPA',
                    },
                    every: true,
                    type: 'LEAF',
                  },
                },
                "ui": {
                  "grid": {
                    "xs": 12,
                    "md": 6,
                    "lg": 4
                  }
                }
              },
              {
                "fieldId": "Procedure_to_convert_CGPA_to__c",
                "required": true,
                "name": "Procedure_to_convert_CGPA_to__c",
                "label": "Procedure to convert CGPA to %",
                "type": "input",
                "validations": {
                  "required": "This field is required",
                  "maxLength": {
                    "value": 255,
                    "message": "This field cannot be more than 255 characters"
                  }
                },
                "rule": {
                  "effect": "SHOW",
                  "condition": {
                    "scope": [
                      "Degree_Complete__c",
                      "Evaluation_type__c"
                    ],
                    "every": true,
                    "expectedValue": {
                      "Degree_Complete__c": "true",
                      "Evaluation_type__c": "CGPA/GPA"
                    },
                    "type": "LEAF"
                  }
                },
                "ui": {
                  "grid": {
                    "xs": 12,
                    "md": 6,
                    "lg": 4
                  }
                }
              },
              {
                "fieldId": "Equivalent_Percentage__c",
                "required": true,
                "name": "Equivalent_Percentage__c",
                "label": "Equivalent Percentage",
                "type": "input",
                "validationType": "numberWithDecimal",
                "validations": {
                  "required": "This field is required",
                  "pattern": {
                    "value": "",
                    "message": "Please enter a valid percentage (maximum 2 digits after the decimal)"
                  },
                  "min": {
                    "value": 1,
                    "message": "This field should not be lesser than 1"
                  },
                  "max": {
                    "value": 100,
                    "message": "This field should not be greater than 100"
                  }
                },
                "rule": {
                  "effect": "SHOW",
                  "condition": {
                    "scope": [
                      "Degree_Complete__c",
                      "Evaluation_type__c"
                    ],
                    "every": true,
                    "expectedValue": {
                      "Degree_Complete__c": "true",
                      "Evaluation_type__c": "CGPA/GPA"
                    },
                    "type": "LEAF"
                  }
                },
                "ui": {
                  "grid": {
                    "xs": 12,
                    "md": 6,
                    "lg": 4
                  }
                }
              },
              {
                fieldId: 'Class_or_Distinction__c',
                required: true,
                name: 'Class_or_Distinction__c',
                label: 'Class or Distinction',
                type: 'select',
                validations: {
                  required: 'This field is required',
                },
                metaData: {
                  optionsKey: 'classDistinctions',
                },
                options: [],
                rule: {
                  effect: 'SHOW',
                  condition: {
                    scope: 'Degree_Complete__c',
                    expectedValue: 'true',
                    type: 'LEAF',
                  },
                },
                ui: {
                  grid: {
                    xs: 12,
                    md: 6,
                    lg: 4,
                  },
                },
              },
              {
                "fieldId": "Evaluation_type__c",
                "name": "Evaluation_type__c",
                "required": true,
                "label": "Evaluation Type",
                "type": "radio",
                "options": [
                  {
                    "label": "CGPA/GPA",
                    "value": "CGPA/GPA"
                  },
                  {
                    "label": "Percentage",
                    "value": "Percentage"
                  }
                ],
                "validations": {
                  "required": "This field is required"
                },
                "rule": {
                  "effect": "SHOW",
                  "condition": {
                    "scope": "Degree_Complete__c",
                    "expectedValue": "false",
                    "type": "LEAF"
                  }
                },
                "ui": {
                  "grid": {
                    "xs": 12,
                    "md": 6,
                    "lg": 4
                  }
                }
              },
              {
                fieldId: 'Maximum_CGPA_GPA_Grade_Percentage_Points__c_II',
                required: true,
                name: 'Maximum_CGPA_GPA_Grade_Percentage_Points__c_II',
                label: 'Maximum Marks',
                validationType: 'numberWithDecimal',
                type: 'input',
                validateField: {
                  scope: 'Obtained_CGPA_GPA_Grade_Percentage_Point__c_II',
                  rule: 'GREATER',
                  message: 'This field cannot be Less than Obtained Marks',
                },
                "rule": {
                  "effect": "SHOW",
                  "condition": {
                    "scope": "Evaluation_type__c",
                    "expectedValue": "Percentage",
                    "type": "LEAF"
                  }
                },
                "validations": {
                  "required": "This field is required",
                  "pattern": {
                    "value": "",
                    "message": "Please enter a valid percentage (maximum 2 digits after the decimal)"
                  },
                  "min": {
                    "value": 1,
                    "message": "This field should not be lesser than 1"
                  },
                  "max": {
                    "value": 1200,
                    "message": "This field should not be greater than 1200"
                  }
                },
                "ui": {
                  "grid": {
                    "xs": 12,
                    "md": 6,
                    "lg": 4
                  }
                }
              },
              {
                fieldId: 'Obtained_CGPA_GPA_Grade_Percentage_Point__c_II',
                required: true,
                name: 'Obtained_CGPA_GPA_Grade_Percentage_Point__c_II',
                label: 'Obtained Marks',
                validationType: 'numberWithDecimal',
                type: 'input',
                validateField: {
                  scope: 'Maximum_CGPA_GPA_Grade_Percentage_Points__c_II',
                  rule: 'LESSER',
                  message: 'This field cannot be more than Total Attainable Marks',
                },
                "rule": {
                  "effect": "SHOW",
                  "condition": {
                    "scope": "Evaluation_type__c",
                    "expectedValue": "Percentage",
                    "type": "LEAF"
                  }
                },
                "validations": {
                  "required": "This field is required",
                  "pattern": {
                    "value": "",
                    "message": "Please enter a valid percentage (maximum 2 digits after the decimal)"
                  },
                  "min": {
                    "value": 1,
                    "message": "This field should not be lesser than 1"
                  },
                  "max": {
                    "value": 1200,
                    "message": "This field should not be greater than 1200"
                  }
                },
                "ui": {
                  "grid": {
                    "xs": 12,
                    "md": 6,
                    "lg": 4
                  }
                }
              },
              {
                fieldId: 'Obtained_CGPA_GPA_Grade_Percentage_Point__c',
                required: true,
                name: 'Obtained_CGPA_GPA_Grade_Percentage_Point__c',
                label: 'Obtained Marks (CGPA/GPA)',
                validationType: 'numberWithDecimal',
                type: 'input',
                validateField: {
                  scope: 'Maximum_CGPA_GPA_Grade_Percentage_Points__c',
                  rule: 'LESSER',
                  message: 'This field cannot be more than Total Attainable Marks',
                },
                validations: {
                  required: 'This field is required',
                  pattern: {
                    value: '',
                    message: 'Please enter a valid CGPA/GPA (maximum 2 digits after the decimal)',
                  },
                  min: {
                    value: 1,
                    message: 'This field should not be lesser than 1',
                  },
                  max: {
                    value: 10,
                    message: 'This field should not be greater than 10',
                  },
                },
                rule: {
                  effect: 'SHOW',
                  condition: {
                    scope: ['Degree_Complete__c', 'Evaluation_type__c'],
                    expectedValue: {
                      Degree_Complete__c: 'false',
                      Evaluation_type__c: 'CGPA/GPA',
                    },
                    every: true,
                    type: 'LEAF',
                  },
                },
                ui: {
                  grid: {
                    xs: 12,
                    md: 6,
                    lg: 4,
                  },
                },
              },
              {
                "fieldId": "Maximum_CGPA_GPA_Grade_Percentage_Points__c",
                "required": true,
                "name": "Maximum_CGPA_GPA_Grade_Percentage_Points__c",
                "label": "Maximum CGPA/GPA",
                "validationType": "number",
                "type": "input",
                "validateField": {
                  "scope": "Obtained_CGPA_GPA_Grade_Percentage_Point__c",
                  "rule": "GREATER",
                  "message": "This field cannot be more than Total Attainable Marks"
                },
                "rule": {
                  "effect": "SHOW",
                  "condition": {
                    "scope": [
                      "Degree_Complete__c",
                      "Evaluation_type__c"
                    ],
                    "expectedValue": {
                      "Degree_Complete__c": "false",
                      "Evaluation_type__c": "CGPA/GPA"
                    },
                    "every": true,
                    "type": "LEAF"
                  }
                },
                "validations": {
                  "required": "This field is required",
                  "pattern": {
                    "value": "",
                    "message": "Please enter a valid CGPA/GPA (Only whole numbers)"
                  },
                  "min": {
                    "value": 1,
                    "message": "This field should not be lesser than 1"
                  },
                  "max": {
                    "value": 10,
                    "message": "This field should not be greater than 10"
                  }
                },
                "ui": {
                  "grid": {
                    "xs": 12,
                    "md": 6,
                    "lg": 4
                  }
                }
              },
              {
                fieldId: 'Equivalent_Percentage__c',
                required: true,
                name: 'Equivalent_Percentage__c',
                label: 'Obtained Percentage',
                validationType: 'numberWithDecimal',
                rule: {
                  effect: 'SHOW',
                  condition: {
                    scope: ['Degree_Complete__c', 'Evaluation_type__c'],
                    expectedValue: {
                      Degree_Complete__c: 'false',
                      Evaluation_type__c: 'Percentage',
                    },
                    every: true,
                    type: 'LEAF',
                  },
                },
                type: 'input',
                validations: {
                  required: 'This field is required',
                  pattern: {
                    value: '',
                    message: 'Please enter a valid percentage (maximum 2 digits after the decimal)',
                  },
                  min: {
                    value: 1,
                    message: 'This field should not be lesser than 1',
                  },
                  max: {
                    value: 100,
                    message: 'This field should not be greater than 100',
                  },
                },
                ui: {
                  grid: {
                    xs: 12,
                    md: 6,
                    lg: 4,
                  },
                },
              },
              {
                fieldId: 'Procedure_to_convert_CGPA_to__c',
                required: true,
                name: 'Procedure_to_convert_CGPA_to__c',
                label: 'Procedure to convert CGPA to %',
                type: 'input',
                validations: {
                  required: 'This field is required',
                  maxLength: {
                    value: 255,
                    message: 'This field cannot be more than 255 characters',
                  },
                },
                rule: {
                  effect: 'SHOW',
                  condition: {
                    scope: ['Degree_Complete__c', 'Evaluation_type__c'],
                    every: true,
                    expectedValue: {
                      Degree_Complete__c: 'false',
                      Evaluation_type__c: 'CGPA/GPA',
                    },
                    type: 'LEAF',
                  },
                },
                ui: {
                  grid: {
                    xs: 12,
                    md: 6,
                    lg: 4,
                  },
                },
              },
              {
                fieldId: 'Equivalent_Percentage__c',
                required: true,
                name: 'Equivalent_Percentage__c',
                label: 'Equivalent Percentage',
                type: 'input',
                validationType: 'numberWithDecimal',
                validations: {
                  required: 'This field is required',
                  pattern: {
                    value: '',
                    message: 'Please enter a valid percentage (maximum 2 digits after the decimal)',
                  },
                  min: {
                    value: 1,
                    message: 'This field should not be lesser than 1',
                  },
                  max: {
                    value: 100,
                    message: 'This field should not be greater than 100',
                  },
                },
                rule: {
                  effect: 'SHOW',
                  condition: {
                    scope: ['Degree_Complete__c', 'Evaluation_type__c'],
                    every: true,
                    expectedValue: {
                      Degree_Complete__c: 'false',
                      Evaluation_type__c: 'CGPA/GPA',
                    },
                    type: 'LEAF',
                  },
                },
                ui: {
                  grid: {
                    xs: 12,
                    md: 6,
                    lg: 4,
                  },
                },
              },
              {
                fieldId: 'Class_or_Distinction__c',
                required: true,
                name: 'Class_or_Distinction__c',
                label: 'Class or Distinction',
                type: 'select',
                validations: {
                  required: 'This field is required',
                },
                metaData: {
                  optionsKey: 'classDistinctions',
                },
                options: [],
                rule: {
                  effect: 'SHOW',
                  condition: {
                    scope: 'Degree_Complete__c',
                    expectedValue: 'false',
                    type: 'LEAF',
                  },
                },
                ui: {
                  grid: {
                    xs: 12,
                    md: 6,
                    lg: 4,
                  },
                },
              },
            ],
          },
        ],
      },
      {
        apiKeyId: '',
        sectionName: 'Additional University Degrees ',
        sectionId: 'educationHistoriesOthers',
        subSectionName: '',
        summarySection: 'Additional University Degrees ',
        sectionPosition: 1,
        sectionType: 'form',
        fields: [
          {
            fieldId: 'educationHistoriesOthers',
            name: 'educationHistoriesOthers',
            label: '',
            type: 'array',
            metaData: {
              addMultiple: true,
              minItems: 0,
              maxLimit: 10,
              name: 'educationHistories',
              removeMultiple: false,
              dynamicTitle: 'Additional University Degrees',
            },
            fieldsArray: [
              {
                fieldId: 'Degree_Type__c',
                name: 'Degree_Type__c',
                label: 'Degree Level',
                type: 'select',
                required: true,
                options: [
                  {
                    label: 'Masters Degree',
                    value: 'Masters Degree',
                  },
                  {
                    label: 'Professional Degree (CA/CS/ICWA)',
                    value: 'Professional Degree (CA/CS/ICWA)',
                  },
                  {
                    label: 'Doctoral Degree',
                    value: 'Doctoral Degree',
                  },
                  {
                    label: 'Others',
                    value: 'Others',
                  },
                ],
                validations: {
                  required: 'This field is required',
                },
                ui: {
                  grid: {
                    xs: 12,
                    md: 6,
                    lg: 4,
                  },
                },
              },
              {
                fieldId: 'Degree_Name__c',
                name: 'Degree_Name__c',
                label: 'Degree Name',
                type: 'select',
                metaData: {
                  optionsKey: 'masterDegree',
                },
                validations: {
                  required: 'This field is required',
                },
                required: true,
                options: [],
                rule: {
                  effect: 'SHOW',
                  condition: {
                    scope: 'Degree_Type__c',
                    expectedValue: 'Masters Degree',
                    type: 'LEAF',
                  },
                },
                ui: {
                  grid: {
                    xs: 12,
                    md: 6,
                    lg: 4,
                  },
                },
              },
              {
                fieldId: 'Degree_Name__c',
                name: 'Degree_Name__c',
                label: 'Degree Name',
                type: 'select',
                metaData: {
                  optionsKey: 'professionalDegree',
                },
                uniqueOptionValues: [],
                uniqueOptions: true,
                required: true,
                validations: {
                  required: 'This field is required',
                },
                rule: {
                  effect: 'SHOW',
                  condition: {
                    scope: 'Degree_Type__c',
                    expectedValue: 'Professional Degree (CA/CS/ICWA)',
                    type: 'LEAF',
                  },
                },
                ui: {
                  grid: {
                    xs: 12,
                    md: 6,
                    lg: 4,
                  },
                },
              },
              {
                fieldId: 'Degree_Name__c',
                name: 'Degree_Name__c',
                label: 'Degree Name',
                type: 'select',
                metaData: {
                  optionsKey: 'doctoralDegree',
                },
                required: true,
                validations: {
                  required: 'This field is required',
                },
                options: [],
                rule: {
                  effect: 'SHOW',
                  condition: {
                    scope: 'Degree_Type__c',
                    expectedValue: 'Doctoral Degree',
                    type: 'LEAF',
                  },
                },
                ui: {
                  grid: {
                    xs: 12,
                    md: 6,
                    lg: 4,
                  },
                },
              },
              {
                fieldId: 'Degree_Name_Other__c',
                name: 'Degree_Name_Other__c',
                label: 'Degree Name Others',
                type: 'input',
                validationType: 'organization',
                required: true,
                validations: {
                  required: 'This field is required',
                  pattern: {
                    value: '',
                    message: 'Please enter a valid degree',
                  },
                  max: {
                    value: 256,
                    message: 'This field cannot be more then 256 characters',
                  },
                },
                rule: {
                  effect: 'SHOW',
                  condition: {
                    scope: 'Degree_Type__c',
                    expectedValue: 'Others',
                    type: 'LEAF',
                  },
                },
                ui: {
                  grid: {
                    xs: 12,
                    md: 6,
                    lg: 4,
                  },
                },
              },
              {
                fieldId: 'Degree_Name_Other__c',
                name: 'Degree_Name_Other__c',
                label: 'Degree Name Others',
                type: 'input',
                helperText: 'Only characters and space',
                validationType: 'alphaWithSpace',
                required: true,
                validations: {
                  required: 'This field is required',
                  pattern: {
                    value: '',
                    message: 'Please enter a valid degree name',
                  },
                },
                ui: {
                  grid: {
                    xs: 12,
                    md: 6,
                    lg: 4,
                  },
                },
                rule: {
                  effect: 'SHOW',
                  condition: {
                    scope: ['Degree_Name__c', 'Degree_Type__c'],
                    every: true,
                    expectedValue: {
                      Degree_Name__c: 'Other',
                      Degree_Type__c: 'Professional Degree (CA/CS/ICWA)',
                    },
                    type: 'LEAF',
                  },
                },
              },
              {
                fieldId: 'Degree_Name_Other__c',
                name: 'Degree_Name_Other__c',
                label: 'Degree Name Others',
                type: 'input',
                helperText: 'Only characters and space',
                validationType: 'alphaWithSpace',
                required: true,
                validations: {
                  required: 'This field is required',
                  pattern: {
                    value: '',
                    message: 'Please enter a valid degree name',
                  },
                },
                ui: {
                  grid: {
                    xs: 12,
                    md: 6,
                    lg: 4,
                  },
                },
                rule: {
                  effect: 'SHOW',
                  condition: {
                    scope: ['Degree_Name__c', 'Degree_Type__c'],
                    every: true,
                    expectedValue: {
                      Degree_Name__c: 'Others',
                      Degree_Type__c: 'Masters Degree',
                    },
                    type: 'LEAF',
                  },
                },
              },
              {
                fieldId: 'Discipline__c',
                name: 'Discipline__c',
                label: 'Discipline (Masters)',
                type: 'select',
                options: [],
                metaData: {
                  optionsKey: 'pgMasters',
                },
                required: true,
                validations: {
                  required: 'This field is required',
                },
                rule: {
                  effect: 'SHOW',
                  condition: {
                    scope: 'Degree_Type__c',
                    expectedValue: 'Masters Degree',
                    type: 'LEAF',
                  },
                },
                ui: {
                  grid: {
                    xs: 12,
                    md: 6,
                    lg: 4,
                  },
                },
              },
              {
                fieldId: 'Discipline_Others__c',
                name: 'Discipline_Others__c',
                required: true,
                label: 'Discipline (Others)',
                type: 'input',
                helperText: 'Only characters and space',
                validationType: 'alphaWithSpace',
                validations: {
                  required: 'This field is required',
                  pattern: {
                    value: '',
                    message: 'Please enter a valid degree name',
                  },
                },
                ui: {
                  grid: {
                    xs: 12,
                    md: 6,
                    lg: 4,
                  },
                },
                rule: {
                  effect: 'SHOW',
                  condition: {
                    scope: ['Discipline__c', 'Degree_Type__c'],
                    every: true,
                    expectedValue: {
                      Discipline__c: 'Others',
                      Degree_Type__c: 'Masters Degree',
                    },
                    type: 'LEAF',
                  },
                },
              },
              {
                fieldId: 'Discipline__c',
                name: 'Discipline__c',
                label: 'Discipline (Professional Degree)',
                type: 'select',
                options: [],
                metaData: {
                  optionsKey: 'pgProfessionalDegree',
                },
                required: true,
                validations: {
                  required: 'This field is required',
                },
                rule: {
                  effect: 'SHOW',
                  condition: {
                    scope: 'Degree_Type__c',
                    expectedValue: 'Professional Degree (CA/CS/ICWA)',
                    type: 'LEAF',
                  },
                },
                ui: {
                  grid: {
                    xs: 12,
                    md: 6,
                    lg: 4,
                  },
                },
              },
              {
                fieldId: 'Discipline__c',
                name: 'Discipline__c',
                label: 'Discipline (Doctoral Degree)',
                type: 'select',
                options: [],
                metaData: {
                  optionsKey: 'pgDoctoralDegree',
                },
                required: true,
                validations: {
                  required: 'This field is required',
                },
                rule: {
                  effect: 'SHOW',
                  condition: {
                    scope: 'Degree_Type__c',
                    expectedValue: 'Doctoral Degree',
                    type: 'LEAF',
                  },
                },
                ui: {
                  grid: {
                    xs: 12,
                    md: 6,
                    lg: 4,
                  },
                },
              },
              {
                fieldId: 'Discipline_Others__c',
                name: 'Discipline_Others__c',
                required: true,
                label: 'Discipline (Others)',
                type: 'input',
                helperText: 'Only characters and space',
                validationType: 'alphaWithSpace',
                validations: {
                  required: 'This field is required',
                  pattern: {
                    value: '',
                    message: 'Please enter a valid degree name',
                  },
                },
                ui: {
                  grid: {
                    xs: 12,
                    md: 6,
                    lg: 4,
                  },
                },
                rule: {
                  effect: 'SHOW',
                  condition: {
                    scope: ['Discipline__c', 'Degree_Type__c'],
                    every: true,
                    expectedValue: {
                      Discipline__c: 'Others',
                      Degree_Type__c: 'Doctoral Degree',
                    },
                    type: 'LEAF',
                  },
                },
              },
              {
                fieldId: 'Discipline__c',
                name: 'Discipline__c',
                label: 'Discipline (Others)',
                type: 'input',
                validationType: 'organization',
                required: true,
                validations: {
                  required: 'This field is required',
                  pattern: {
                    value: '',
                    message: 'Please enter a valid discipline',
                  },
                  maxLength: {
                    value: 256,
                    message: 'This field cannot be more than 256 characters',
                  },
                },
                rule: {
                  effect: 'SHOW',
                  condition: {
                    scope: 'Degree_Type__c',
                    expectedValue: 'Others',
                    type: 'LEAF',
                  },
                },
                ui: {
                  grid: {
                    xs: 12,
                    md: 6,
                    lg: 4,
                  },
                },
              },
              {
                fieldId: 'Specialization__c',
                name: 'Specialization__c',
                label: 'Specialization',
                type: 'input',
                validationType: 'organization',
                required: true,
                validations: {
                  required: 'This field is required',
                  pattern: {
                    value: '',
                    message: 'Please enter a valid specialization',
                  },
                  maxLength: {
                    value: 64,
                    message: 'This field cannot be more than 64 characters',
                  },
                },
                ui: {
                  grid: {
                    xs: 12,
                    md: 6,
                    lg: 4,
                  },
                },
              },
              {
                fieldId: 'hed__Educational_Institution_Name__c',
                name: 'hed__Educational_Institution_Name__c',
                label: 'Institution Name',
                type: 'input',
                validationType: 'organization',
                required: true,
                validations: {
                  required: 'This field is required',
                  pattern: {
                    value: '',
                    message: 'Please enter a valid institution/university name',
                  },
                  maxLength: {
                    value: 255,
                    message: 'This field cannot be more than 255 characters',
                  },
                },
                ui: {
                  grid: {
                    xs: 12,
                    md: 6,
                    lg: 4,
                  },
                },
              },
              {
                fieldId: 'Duration_of_the_Program__c',
                name: 'Duration_of_the_Program__c',
                label: 'Duration of the program',
                type: 'select',
                required: true,
                metaData: {
                  optionsKey: 'durationOfTheProgramMasters',
                },
                validations: {
                  required: 'This field is required',
                },
                rule: {
                  effect: 'SHOW',
                  condition: {
                    scope: 'Degree_Type__c',
                    expectedValue: 'Masters Degree',
                    type: 'LEAF',
                  },
                },
                ui: {
                  grid: {
                    xs: 12,
                    md: 6,
                    lg: 4,
                  },
                },
              },
              {
                fieldId: 'University_Type__c',
                name: 'University_Type__c',
                label: 'University Type',
                type: 'select',
                metaData: {
                  optionsKey: 'universityType',
                },
                options: [],
                required: true,
                validations: {
                  required: 'This field is required',
                },
                ui: {
                  grid: {
                    xs: 12,
                    md: 6,
                    lg: 4,
                  },
                },
              },
              {
                fieldId: 'University_Others__c',
                name: 'University_Others__c',
                label: 'University Type Others',
                type: 'input',
                validationType: 'organization',
                rule: {
                  effect: 'SHOW',
                  condition: {
                    scope: 'University_Type__c',
                    expectedValue: 'Others',
                    type: 'LEAF',
                  },
                },
                required: true,
                validations: {
                  required: 'This field is required',
                  pattern: {
                    value: '',
                    message: 'Please enter a valid university',
                  },
                  maxLength: {
                    value: 256,
                    message: 'This field cannot be greater than 256 characters',
                  },
                },
                ui: {
                  grid: {
                    xs: 12,
                    md: 6,
                    lg: 4,
                  },
                },
              },
              {
                fieldId: 'Degree_Complete__c',
                name: 'Degree_Complete__c',
                label: 'Degree Complete ?',
                type: 'radio',
                required: true,
                options: [
                  {
                    label: 'Yes',
                    value: true,
                  },
                  {
                    label: 'No',
                    value: false,
                  },
                ],
                validations: {
                  required: 'This field is required',
                },
                ui: {
                  grid: {
                    xs: 12,
                    md: 6,
                    lg: 4,
                  },
                },
              },
              {
                fieldId: 'Year_of_Completion__c',
                name: 'Year_of_Completion__c',
                label: 'Year of completion (Awaited)',
                type: 'date',
                views: ['year', 'month', 'day'],
                format: 'YYYY-MMM-DD',
                maxDate: 1,
                minDate: true,
                required: true,
                validations: {
                  required: 'This field is required',
                },
                rule: {
                  effect: 'SHOW',
                  condition: {
                    scope: 'Degree_Complete__c',
                    expectedValue: 'false',
                    type: 'LEAF',
                  },
                },
                ui: {
                  grid: {
                    xs: 12,
                    md: 6,
                    lg: 4,
                  },
                },
              },
              {
                fieldId: 'Year_of_Completion__c',
                name: 'Year_of_Completion__c',
                label: 'Year of completion',
                type: 'date',
                views: ['year', 'month', 'day'],
                format: 'YYYY-MMM-DD',
                maxDate: true,
                required: true,
                minDate: {
                  scope: 'educationHistories.1.Year_of_Completion__c',
                  constant: true,
                  add: {
                    value: 3,
                    unit: 'years',
                    startOf: 'years',
                  },
                },
                validations: {
                  required: 'This field is required',
                },
                rule: {
                  effect: 'SHOW',
                  condition: {
                    scope: 'Degree_Complete__c',
                    expectedValue: 'true',
                    type: 'LEAF',
                  },
                },
                ui: {
                  grid: {
                    xs: 12,
                    md: 6,
                    lg: 4,
                  },
                },
              },
              {
                fieldId: 'Evaluation_type__c',
                name: 'Evaluation_type__c',
                required: true,
                label: 'Evaluation Type',
                type: 'radio',
                options: [
                  {
                    label: 'CGPA/GPA',
                    value: 'CGPA/GPA',
                  },
                  {
                    label: 'Percentage',
                    value: 'Percentage',
                  },
                ],
                validations: {
                  required: 'This field is required',
                },
                rule: {
                  effect: 'SHOW',
                  condition: {
                    scope: 'Degree_Complete__c',
                    expectedValue: 'true',
                    type: 'LEAF',
                  },
                },
                ui: {
                  grid: {
                    xs: 12,
                    md: 6,
                    lg: 4,
                  },
                },
              },
              {
                "fieldId": "Obtained_CGPA_GPA_Grade_Percentage_Point__c",
                "required": true,
                "name": "Obtained_CGPA_GPA_Grade_Percentage_Point__c",
                "label": "Obtained Marks (CGPA/GPA)",
                "validationType": "numberWithDecimal",
                "type": "input",
                "validateField": {
                  "scope": "Maximum_CGPA_GPA_Grade_Percentage_Points__c",
                  "rule": "LESSER",
                  "message": "This field cannot be more than Total Attainable Marks"
                },
                "validations": {
                  "required": "This field is required",
                  "pattern": {
                    "value": "",
                    "message": "Please enter a valid CGPA/GPA (maximum 2 digits after the decimal)"
                  },
                  "min": {
                    "value": 1,
                    "message": "This field should not be lesser than 1"
                  },
                  "max": {
                    "value": 10,
                    "message": "This field should not be greater than 10"
                  }
                },
                rule: {
                  effect: 'SHOW',
                  condition: {
                    scope: ['Degree_Complete__c', 'Evaluation_type__c'],
                    expectedValue: {
                      Degree_Complete__c: 'false',
                      Evaluation_type__c: 'CGPA/GPA',
                    },
                    "every": true,
                    "type": "LEAF"
                  }
                },
                "ui": {
                  "grid": {
                    "xs": 12,
                    "md": 6,
                    "lg": 4
                  }
                }
              },
              {
                fieldId: 'Equivalent_Percentage__c_II',
                required: true,
                name: 'Equivalent_Percentage__c_II',
                label: 'Obtained Percentage',
                validationType: 'numberWithDecimal',
                rule: {
                  effect: 'SHOW',
                  condition: {
                    scope: ['Degree_Complete__c', 'Evaluation_type__c'],
                    expectedValue: {
                      Degree_Complete__c: 'true',
                      Evaluation_type__c: 'Percentage',
                    },
                    "every": true,
                    "type": "LEAF"
                  }
                },
                "type": "input",
                "validations": {
                  "required": "This field is required",
                  "pattern": {
                    "value": "",
                    "message": "Please enter a valid percentage (maximum 2 digits after the decimal)"
                  },
                  "min": {
                    "value": 1,
                    "message": "This field should not be lesser than 1"
                  },
                  "max": {
                    "value": 100,
                    "message": "This field should not be greater than 100"
                  }
                },
                "ui": {
                  "grid": {
                    "xs": 12,
                    "md": 6,
                    "lg": 4
                  }
                }
              },
              {
                fieldId: 'Equivalent_Percentage__c_II',
                required: true,
                name: 'Equivalent_Percentage__c_II',
                label: 'Obtained Percentage',
                validationType: 'numberWithDecimal',
                rule: {
                  effect: 'SHOW',
                  condition: {
                    scope: ['Degree_Complete__c', 'Evaluation_type__c'],
                    expectedValue: {
                      Degree_Complete__c: 'false',
                      Evaluation_type__c: 'Percentage',
                    },
                    every: true,
                    type: 'LEAF',
                  },
                },
                type: 'input',
                validations: {
                  required: 'This field is required',
                  pattern: {
                    value: '',
                    message: 'Please enter a valid percentage (maximum 2 digits after the decimal)',
                  },
                  "min": {
                    "value": 1,
                    "message": "This field should not be lesser than 1"
                  },
                  "max": {
                    "value": 100,
                    "message": "This field should not be greater than 100"
                  }
                },
                ui: {
                  grid: {
                    xs: 12,
                    md: 6,
                    lg: 4,
                  },
                },
              },
              {
                "fieldId": "Class_or_Distinction__c",
                "required": true,
                "name": "Class_or_Distinction__c",
                "label": "Class or Distinction",
                "type": "select",
                "validations": {
                  "required": "This field is required"
                },
                "metaData": {
                  "optionsKey": "classDistinctions"
                },
                "options": [],
                "rule": {
                  "effect": "SHOW",
                  "condition": {
                    "scope": "Degree_Complete__c",
                    "expectedValue": "true",
                    "type": "LEAF"
                  }
                },
                "ui": {
                  "grid": {
                    "xs": 12,
                    "md": 6,
                    "lg": 4
                  }
                }
              },
              {
                fieldId: 'Evaluation_type__c',
                name: 'Evaluation_type__c',
                required: true,
                label: 'Evaluation Type',
                type: 'radio',
                options: [
                  {
                    label: 'CGPA/GPA',
                    value: 'CGPA/GPA',
                  },
                  {
                    label: 'Percentage',
                    value: 'Percentage',
                  },
                ],
                validations: {
                  required: 'This field is required',
                },
                rule: {
                  effect: 'SHOW',
                  condition: {
                    scope: 'Degree_Complete__c',
                    expectedValue: 'false',
                    type: 'LEAF',
                  },
                },
                ui: {
                  grid: {
                    xs: 12,
                    md: 6,
                    lg: 4,
                  },
                },
              },
              {
                fieldId: 'Obtained_CGPA_GPA_Grade_Percentage_Point__c',
                required: true,
                name: 'Obtained_CGPA_GPA_Grade_Percentage_Point__c',
                label: 'Obtained Marks (CGPA/GPA)',
                validationType: 'numberWithDecimal',
                type: 'input',
                validateField: {
                  scope: 'Maximum_CGPA_GPA_Grade_Percentage_Points__c',
                  rule: 'LESSER',
                  message: 'This field cannot be more than Total Attainable Marks',
                },
                validations: {
                  required: 'This field is required',
                  pattern: {
                    value: '',
                    message: 'Please enter a valid CGPA/GPA (maximum 2 digits after the decimal)',
                  },
                  min: {
                    value: 1,
                    message: 'This field should not be lesser than 1',
                  },
                  max: {
                    value: 10,
                    message: 'This field should not be greater than 10',
                  },
                },
                rule: {
                  effect: 'SHOW',
                  condition: {
                    scope: ['Degree_Complete__c', 'Evaluation_type__c'],
                    expectedValue: {
                      Degree_Complete__c: 'false',
                      Evaluation_type__c: 'CGPA/GPA',
                    },
                    every: true,
                    type: 'LEAF',
                  },
                },
                ui: {
                  grid: {
                    xs: 12,
                    md: 6,
                    lg: 4,
                  },
                },
              },
              {
                fieldId: 'Maximum_CGPA_GPA_Grade_Percentage_Points__c',
                required: true,
                name: 'Maximum_CGPA_GPA_Grade_Percentage_Points__c',
                label: 'Maximum CGPA/GPA',
                validationType: 'number',
                type: 'input',
                validateField: {
                  scope: 'Obtained_CGPA_GPA_Grade_Percentage_Point__c',
                  rule: 'GREATER',
                  message: 'This field cannot be more than Total Attainable Marks',
                },
                rule: {
                  effect: 'SHOW',
                  condition: {
                    scope: ['Degree_Complete__c', 'Evaluation_type__c'],
                    expectedValue: {
                      Degree_Complete__c: 'false',
                      Evaluation_type__c: 'CGPA/GPA',
                    },
                    every: true,
                    type: 'LEAF',
                  },
                },
                validations: {
                  required: 'This field is required',
                  pattern: {
                    value: '',
                    message: 'Please enter a valid CGPA/GPA (Only whole numbers)',
                  },
                  min: {
                    value: 1,
                    message: 'This field should not be lesser than 1',
                  },
                  max: {
                    value: 10,
                    message: 'This field should not be greater than 10',
                  },
                },
                ui: {
                  grid: {
                    xs: 12,
                    md: 6,
                    lg: 4,
                  },
                },
              },
              {
                fieldId: 'Equivalent_Percentage__c',
                required: true,
                name: 'Equivalent_Percentage__c',
                label: 'Obtained Percentage',
                validationType: 'numberWithDecimal',
                rule: {
                  effect: 'SHOW',
                  condition: {
                    scope: ['Degree_Complete__c', 'Evaluation_type__c'],
                    expectedValue: {
                      Degree_Complete__c: 'false',
                      Evaluation_type__c: 'Percentage',
                    },
                    every: true,
                    type: 'LEAF',
                  },
                },
                type: 'input',
                validations: {
                  required: 'This field is required',
                  pattern: {
                    value: '',
                    message: 'Please enter a valid percentage (maximum 2 digits after the decimal)',
                  },
                  min: {
                    value: 1,
                    message: 'This field should not be lesser than 1',
                  },
                  max: {
                    value: 100,
                    message: 'This field should not be greater than 100',
                  },
                },
                ui: {
                  grid: {
                    xs: 12,
                    md: 6,
                    lg: 4,
                  },
                },
              },
              {
                "fieldId": "Procedure_to_convert_CGPA_to__c",
                "required": true,
                "name": "Procedure_to_convert_CGPA_to__c",
                "label": "Procedure to convert CGPA to %",
                "type": "input",
                "validations": {
                  "required": "This field is required",
                  "maxLength": {
                    "value": 255,
                    "message": "This field cannot be more than 255 characters"
                  }
                },
                "rule": {
                  "effect": "SHOW",
                  "condition": {
                    "scope": [
                      "Degree_Complete__c",
                      "Evaluation_type__c"
                    ],
                    "every": true,
                    "expectedValue": {
                      "Degree_Complete__c": "false",
                      "Evaluation_type__c": "CGPA/GPA"
                    },
                    "type": "LEAF"
                  }
                },
                "ui": {
                  "grid": {
                    "xs": 12,
                    "md": 6,
                    "lg": 4
                  }
                }
              },
              {
                "fieldId": "Equivalent_Percentage__c",
                "required": true,
                "name": "Equivalent_Percentage__c",
                "label": "Equivalent Percentage",
                "type": "input",
                "validationType": "numberWithDecimal",
                "validations": {
                  "required": "This field is required",
                  "pattern": {
                    "value": "",
                    "message": "Please enter a valid percentage (maximum 2 digits after the decimal)"
                  },
                  "min": {
                    "value": 1,
                    "message": "This field should not be lesser than 1"
                  },
                  "max": {
                    "value": 100,
                    "message": "This field should not be greater than 100"
                  }
                },
                "rule": {
                  "effect": "SHOW",
                  "condition": {
                    "scope": [
                      "Degree_Complete__c",
                      "Evaluation_type__c"
                    ],
                    "every": true,
                    "expectedValue": {
                      "Degree_Complete__c": "false",
                      "Evaluation_type__c": "CGPA/GPA"
                    },
                    "type": "LEAF"
                  }
                },
                "ui": {
                  "grid": {
                    "xs": 12,
                    "md": 6,
                    "lg": 4
                  }
                }
              },
              {
                "fieldId": "Class_or_Distinction__c",
                "required": true,
                "name": "Class_or_Distinction__c",
                "label": "Class or Distinction",
                "type": "select",
                "validations": {
                  "required": "This field is required"
                },
                "metaData": {
                  "optionsKey": "classDistinctions"
                },
                "options": [],
                "rule": {
                  "effect": "SHOW",
                  "condition": {
                    "scope": "Degree_Complete__c",
                    "expectedValue": "false",
                    "type": "LEAF"
                  }
                },
                "ui": {
                  "grid": {
                    "xs": 12,
                    "md": 6,
                    "lg": 4
                  }
                }
              }
            ]
          }
        ]
      }
    ]
  },
  {
    stepId: 'workExperience',
    stepName: 'Research and Work Experience',
    showStepName: false,
    stepVisible: true,
    stepPosition: 1,
    stepType: 'form',
    sections: [
      {
        sectionId: 'researchInfo',
        sectionName: 'Research Experience',
        subSectionName: '',
        sectionPosition: 6,
        sectionType: 'form',
        fields: [
          {
            fieldId: 'application[Do_you_have_any_research_experience__c]',
            required: true,
            name: 'application[Do_you_have_any_research_experience__c]',
            label: 'Do you have any research experience ?',
            type: 'radio',
            options: [
              {
                label: 'Yes',
                value: true,
              },
              {
                label: 'No',
                value: false,
              },
            ],
            validations: {
              required: 'This field is required',
            },
            ui: {
              grid: {
                xs: 12,
                md: 12,
                lg: 12,
              },
            },
          },
          {
            fieldId: 'researchExperience',
            name: 'researchExperience',
            label: 'Research Experience',
            type: 'array',
            metaData: {
              addMultiple: true,
              minItems: 1,
              maxLimit: 10,
              name: 'workExperiences',
              removeMultiple: false,
              dynamicTitle: 'Research Experience',
            },
            rule: {
              effect: 'SHOW',
              condition: {
                scope: 'application[Do_you_have_any_research_experience__c]',
                expectedValue: 'true',
                type: 'LEAF',
              },
            },
            fieldsArray: [
              {
                fieldId: 'Organisation_Name__c',
                name: 'Organisation_Name__c',
                label: 'Organization',
                type: 'input',
                required: true,
                validationType: 'alphaNumberic',
                validations: {
                  required: 'This field is required',
                  maxLength: {
                    value: 128,
                    message: 'This field cannot be greater than 128 characters',
                  },
                  pattern: {
                    value: '',
                    message: 'Please enter a valid organization name',
                  },
                },
                ui: {
                  grid: {
                    xs: 12,
                    md: 6,
                    lg: 4,
                  },
                },
              },
              {
                fieldId: 'Designation__c',
                name: 'Designation__c',
                label: 'Designation',
                type: 'input',
                required: true,
                validationType: 'alphaNumeric',
                validations: {
                  required: 'This field is required',
                  maxLength: {
                    value: 128,
                    message: 'This field cannot be more than 128 characters',
                  },
                },
                ui: {
                  grid: {
                    xs: 12,
                    md: 6,
                    lg: 4,
                  },
                },
              },
              {
                fieldId: 'Start_Date__c',
                required: true,
                name: 'Start_Date__c',
                label: 'Date Of Joining',
                type: 'date',
                format: 'YYYY-MM-DD',
                maxDate: true,
                minDate: {
                  scope: 'applicant[Birthdate]',
                  constant: true,
                  add: {
                    value: 10,
                    unit: 'years',
                  },
                },
                validations: {
                  required: 'This field is required',
                },
                ui: {
                  grid: {
                    xs: 12,
                    md: 6,
                    lg: 4,
                  },
                },
              },
              {
                fieldId: 'Currently_employed__c',
                name: 'Currently_employed__c',
                label: 'Currently Working ?',
                type: 'radio',
                options: [
                  {
                    label: 'Yes',
                    value: true,
                  },
                  {
                    label: 'No',
                    value: false,
                  },
                ],
                required: true,
                validations: {
                  required: 'This field is required',
                },
                ui: {
                  grid: {
                    xs: 12,
                    md: 6,
                    lg: 4,
                  },
                },
              },
              {
                fieldId: 'End_Date_Set__c',
                name: 'End_Date_Set__c',
                label: 'Release Date',
                type: 'date',
                required: true,
                format: 'YYYY-MM-DD',
                minDate: {
                  scope: 'Start_Date__c',
                },
                metaData: {
                  value: 'current',
                },
                ui: {
                  grid: {
                    xs: 12,
                    md: 6,
                    lg: 4,
                  },
                },
                hide: true,
                rule: {
                  effect: 'SHOW',
                  unregister: true,
                  condition: {
                    scope: 'Currently_employed__c',
                    expectedValue: 'true',
                    type: 'LEAF',
                  },
                },
              },
              {
                fieldId: 'End_Date__c',
                required: true,
                name: 'End_Date__c',
                label: 'Release Date',
                type: 'date',
                format: 'YYYY-MM-DD',
                maxDate: true,
                minDate: {
                  scope: 'Start_Date__c',
                },
                validations: {
                  required: 'This field is required',
                },
                rule: {
                  effect: 'SHOW',
                  condition: {
                    scope: 'Currently_employed__c',
                    expectedValue: 'false',
                    type: 'LEAF',
                  },
                },
                ui: {
                  grid: {
                    xs: 12,
                    md: 6,
                    lg: 4,
                  },
                },
              },
              {
                fieldId: 'Remuneration_Currency__c',
                name: 'Remuneration_Currency__c',
                label: 'Renumeration Currency',
                type: 'select',
                required: true,
                validations: {
                  required: 'This field is required',
                },
                options: [],
                metaData: {
                  optionsKey: 'currency',
                },
                ui: {
                  grid: {
                    xs: 12,
                    md: 6,
                    lg: 4,
                  },
                },
              },
              {
                fieldId: 'Renumeration_Currency_Other__c',
                name: 'Renumeration_Currency_Other__c',
                label: 'Renumeration Currency Other',
                type: 'input',
                required: true,
                validationType: 'organization',
                validations: {
                  required: 'This field is required',
                  pattern: {
                    value: '',
                    message: 'Please enter a valid currency code',
                  },
                },
                rule: {
                  effect: 'SHOW',
                  condition: {
                    scope: 'Remuneration_Currency__c',
                    expectedValue: 'Others',
                    type: 'LEAF',
                  },
                },
                ui: {
                  grid: {
                    xs: 12,
                    md: 6,
                    lg: 4,
                  },
                },
              },
              {
                fieldId: 'Annual_Remuneration_in_CTC__c',
                required: true,
                name: 'Annual_Remuneration_in_CTC__c',
                label: 'Gross Annual Salary',
                type: 'input',
                textFormat: 'currency',
                validations: {
                  required: 'This field is required',
                  pattern: {
                    value: '',
                    message: 'Please enter a valid CTC',
                  },
                  maxLength: {
                    value: 14,
                    message: 'This field cannot be more than 14 characters',
                  },
                },
                ui: {
                  grid: {
                    xs: 12,
                    md: 6,
                    lg: 4,
                  },
                },
              },
              {
                fieldId: 'Nature_of_Research__c',
                required: true,
                name: 'Nature_of_Research__c',
                label: 'Nature Of Research',
                type: 'input',
                multiline: true,
                rows: 4,
                validations: {
                  maxLength: {
                    value: 500,
                    message: 'This field cannot be greater than 500 characters',
                  },
                },
                remaining: true,
                maxCharacters: 500,
                ui: {
                  grid: {
                    xs: 12,
                    md: 12,
                    lg: 12,
                  },
                },
              },
            ],
          },
        ],
      },
      {
        sectionId: 'employmentDetails',
        sectionName: 'Work Experience',
        subSectionName: '',
        sectionPosition: 3,
        sectionType: 'form',
        fields: [
          {
            fieldId: 'application[Do_you_have_any_work_experience__c]',
            required: true,
            name: 'application[Do_you_have_any_work_experience__c]',
            label: 'Do you have any work experience ?',
            type: 'radio',
            options: [
              {
                label: 'Yes',
                value: true,
              },
              {
                label: 'No',
                value: false,
              },
            ],
            validations: {
              required: 'This field is required',
            },
            ui: {
              grid: {
                xs: 12,
                md: 12,
                lg: 12,
              },
            },
          },
          {
            fieldId: 'workExperiences',
            name: 'workExperiences',
            label: 'Work Experiences',
            type: 'array',
            rule: {
              effect: 'SHOW',
              condition: {
                scope: 'application[Do_you_have_any_work_experience__c]',
                expectedValue: 'true',
                type: 'LEAF',
              },
            },
            metaData: {
              addMultiple: true,
              minItems: 1,
              maxLimit: 10,
              removeMultiple: false,
              name: 'workExperiences',
              dynamicTitle: 'Work Experience',
            },
            fieldsArray: [
              {
                fieldId: 'Organisation_Name__c',
                name: 'Organisation_Name__c',
                label: 'Organization Name',
                type: 'input',
                required: true,
                validationType: 'organization',
                validations: {
                  required: 'This field is required',
                  pattern: {
                    value: '',
                    message: 'Please enter a valid organization name',
                  },
                  maxLength: {
                    value: 128,
                    message: 'This field cannot be greater than 128 characters',
                  },
                },
                ui: {
                  grid: {
                    xs: 12,
                    md: 6,
                    lg: 4,
                  },
                },
              },
              {
                fieldId: 'Organisation_Type__c',
                name: 'Organisation_Type__c',
                label: 'Organization Type',
                type: 'select',
                required: true,
                metaData: {
                  optionsKey: 'organizationType',
                },
                options: [],
                validations: {
                  required: 'This field is required',
                },
                ui: {
                  grid: {
                    xs: 12,
                    md: 6,
                    lg: 4,
                  },
                },
              },
              {
                fieldId: 'Organisation_Type_Others__c',
                name: 'Organisation_Type_Others__c',
                label: 'Organization Type Other',
                type: 'input',
                required: true,
                validations: {
                  required: 'This field is required',
                  maxLength: {
                    value: 200,
                    message: 'This field cannot be more than 200 characters',
                  },
                },
                rule: {
                  effect: 'SHOW',
                  condition: {
                    scope: 'Organisation_Type__c',
                    expectedValue: 'Others',
                    type: 'LEAF',
                  },
                },
                ui: {
                  grid: {
                    xs: 12,
                    md: 6,
                    lg: 4,
                  },
                },
              },
              {
                fieldId: 'Industry_Type__c',
                name: 'Industry_Type__c',
                label: 'Industry Type',
                type: 'select',
                required: true,
                options: [],
                metaData: {
                  optionsKey: 'industryType',
                },
                validations: {
                  required: 'This field is required',
                },
                ui: {
                  grid: {
                    xs: 12,
                    md: 6,
                    lg: 4,
                  },
                },
              },
              {
                fieldId: 'Industry_Type_Others__c',
                name: 'Industry_Type_Others__c',
                label: 'Industry Type Others',
                type: 'input',
                required: true,
                options: [],
                validations: {
                  required: 'This field is required',
                  maxLength: {
                    value: 100,
                    message: 'This field cannot be more than 100 characters',
                  },
                },
                rule: {
                  effect: 'SHOW',
                  condition: {
                    scope: 'Industry_Type__c',
                    expectedValue: 'Others',
                    type: 'LEAF',
                  },
                },
                ui: {
                  grid: {
                    xs: 12,
                    md: 6,
                    lg: 4,
                  },
                },
              },
              {
                fieldId: 'Designation__c',
                name: 'Designation__c',
                label: 'Designation',
                type: 'input',
                required: true,
                validations: {
                  required: 'This field is required',
                  maxLength: {
                    value: 128,
                    message: 'This field cannot be more than 128 characters',
                  },
                },
                ui: {
                  grid: {
                    xs: 12,
                    md: 6,
                    lg: 4,
                  },
                },
              },
              {
                fieldId: 'Start_Date__c',
                name: 'Start_Date__c',
                label: 'Date Of Joining',
                type: 'date',
                format: 'YYYY-MM-DD',
                required: true,
                validations: {
                  required: 'This field is required',
                },
                minDate: {
                  scope: 'applicant[Birthdate]',
                  constant: true,
                  add: {
                    value: 10,
                    unit: 'years',
                  },
                },
                maxDate: true,
                ui: {
                  grid: {
                    xs: 12,
                    md: 6,
                    lg: 4,
                  },
                },
              },
              {
                fieldId: 'Currently_employed__c',
                name: 'Currently_employed__c',
                label: 'Currently employed ?',
                type: 'radio',
                uniqueData: 'true',
                disabled: false,
                options: [
                  {
                    label: 'Yes',
                    value: true,
                  },
                  {
                    label: 'No',
                    value: false,
                  },
                ],
                required: true,
                validations: {
                  required: 'This field is required',
                },
                ui: {
                  grid: {
                    xs: 12,
                    md: 6,
                    lg: 4,
                  },
                },
              },
              {
                fieldId: 'End_Date_Set__c',
                name: 'End_Date_Set__c',
                label: 'Date Of Relieving',
                type: 'date',
                required: true,
                format: 'YYYY-MM-DD',
                minDate: {
                  scope: 'Start_Date__c',
                },
                metaData: {
                  value: 'current',
                },
                ui: {
                  grid: {
                    xs: 12,
                    md: 6,
                    lg: 4,
                  },
                },
                hide: true,
                rule: {
                  effect: 'SHOW',
                  condition: {
                    scope: 'Currently_employed__c',
                    expectedValue: 'true',
                    type: 'LEAF',
                  },
                },
              },
              {
                fieldId: 'End_Date__c',
                name: 'End_Date__c',
                label: 'Date Of Relieving',
                type: 'date',
                required: true,
                format: 'YYYY-MM-DD',
                validations: {
                  required: 'This field is required',
                },
                minDate: {
                  scope: 'Start_Date__c',
                },
                maxDate: 1,
                ui: {
                  grid: {
                    xs: 12,
                    md: 6,
                    lg: 4,
                  },
                },
                rule: {
                  effect: 'SHOW',
                  condition: {
                    scope: 'Currently_employed__c',
                    expectedValue: 'false',
                    type: 'LEAF',
                  },
                },
              },
              {
                fieldId: 'Total_months_of_experience_as_on_Date__c',
                name: 'Total_months_of_experience_as_on_Date__c',
                label: 'Total months of experience (in months)',
                type: 'input',
                format: 'YYYY-MM-DD',
                summaryOnly: true,
                disabled: true,
                formulas: {
                  type: 'date',
                  scopeFields: {
                    operator1: 'Start_Date__c',
                    operator2: 'End_Date__c',
                  },
                  operation: 'SUB',
                },
                ui: {
                  grid: {
                    xs: 12,
                    md: 6,
                    lg: 4,
                  },
                },
              },
              {
                fieldId: 'Remuneration_Currency__c',
                name: 'Remuneration_Currency__c',
                label: 'Renumeration Currency',
                type: 'select',
                required: true,
                validations: {
                  required: 'This field is required',
                },
                options: [],
                metaData: {
                  optionsKey: 'currency',
                },
                ui: {
                  grid: {
                    xs: 12,
                    md: 6,
                    lg: 4,
                  },
                },
              },
              {
                fieldId: 'Renumeration_Currency_Other__c',
                name: 'Renumeration_Currency_Other__c',
                label: 'Renumeration Currency Other',
                type: 'input',
                required: true,
                validationType: 'organization',
                validations: {
                  required: 'This field is required',
                  pattern: {
                    value: '',
                    message: 'Please enter a valid currency code',
                  },
                },
                rule: {
                  effect: 'SHOW',
                  condition: {
                    scope: 'Remuneration_Currency__c',
                    expectedValue: 'Others',
                    type: 'LEAF',
                  },
                },
                ui: {
                  grid: {
                    xs: 12,
                    md: 6,
                    lg: 4,
                  },
                },
              },
              {
                fieldId: 'Annual_Remuneration_in_CTC__c',
                name: 'Annual_Remuneration_in_CTC__c',
                label: 'Annual Renumeration',
                type: 'input',
                required: true,
                textFormat: 'currency',
                validations: {
                  required: 'This field is required',
                  pattern: {
                    value: '',
                    message: 'Please enter a valid CTC',
                  },
                  maxLength: {
                    value: 14,
                    message: 'This field cannot be more than 14 characters',
                  },
                },
                ui: {
                  grid: {
                    xs: 12,
                    md: 6,
                    lg: 4,
                  },
                },
              },
              {
                fieldId: 'International_Exposure__c',
                name: 'International_Exposure__c',
                label: 'Did/does it offer international exposure ?',
                type: 'radio',
                required: true,
                options: [
                  {
                    value: true,
                    label: 'Yes',
                  },
                  {
                    label: 'No',
                    value: false,
                  },
                ],
                validations: {
                  required: 'This field is required',
                },
                ui: {
                  grid: {
                    xs: 12,
                    md: 6,
                    lg: 4,
                  },
                },
              },
              {
                fieldId: 'Role_KRA__c',
                name: 'Role_KRA__c',
                label: 'Roles/KRA',
                type: 'input',
                required: true,
                multiline: true,
                rows: 4,
                remaining: true,
                maxCharacters: 500,
                validations: {
                  required: 'This field is required',
                  maxLength: {
                    value: 500,
                    message: 'This field cannot be more than 500 characters',
                  },
                },
                ui: {
                  gridType: 'fullRow',
                },
              },
            ],
          },
          {
            fieldId: 'application[Overall_work_Experience__c]',
            required: true,
            name: 'application[Overall_work_Experience__c]',
            label: 'Overall work experience (as per system logic)',
            type: 'input',
            validationType: 'number',
            summaryOnly: true,
            ui: {
              grid: {
                xs: 12,
                md: 6,
                lg: 4,
              },
            },
          },
        ],
      },
    ],
  },
  {
    stepId: 'additionalInfo',
    stepName: 'Additional Information',
    showStepName: false,
    stepVisible: true,
    stepPosition: 1,
    stepType: 'form',
    sections: [
      {
        "sectionId": "extracurricular",
        "sectionName": "Extra Curricular Activities",
        "subSectionName": "",
        "sectionPosition": 6,
        "sectionType": "form",
        "fields": [
          {
            "fieldId": "application[Extra_Curricular_Activities__c]",
            "name": "application[Extra_Curricular_Activities__c]",
            "label": "Extra Curricular Activities",
            "type": "input",
            "multiline": true,
            "rows": 6,
            "validations": {
              "maxLength": {
                "value": 4000,
                "message": "This field cannot be greater than 4000 characters"
              }
            },
            "remaining": true,
            "maxCharacters": 4000,
            "ui": {
              "grid": {
                "xs": 12,
                "md": 12,
                "lg": 12
              }
            }
          }
        ]
      },
      {
        "sectionId": "awards",
        "sectionName": "Awards & Distinctions",
        "subSectionName": "",
        "sectionPosition": 6,
        "sectionType": "form",
        "fields": [
          {
            "fieldId": "application[Awards_Distinctions__c]",
            "name": "application[Awards_Distinctions__c]",
            "label": "Awards & Distinctions",
            "type": "input",
            "multiline": true,
            "rows": 6,
            "validations": {
              "maxLength": {
                "value": 4000,
                "message": "This field cannot be greater than 4000 characters"
              }
            },
            "remaining": true,
            "maxCharacters": 4000,
            "ui": {
              "grid": {
                "xs": 12,
                "md": 12,
                "lg": 12
              }
            }
          }
        ]
      },
      {
        sectionId: 'docProof',
        sectionName: 'Type of Doc Proof',
        subSectionName: '',
        sectionPosition: 6,
        sectionType: 'form',
        fields: [
          {
            fieldId: 'application[Doc_Proof__c]',
            name: 'application[Doc_Proof__c]',
            label: 'Type of Doc Proof (Upload any one proof as applicable)',
            type: 'select',
            required: true,
            validations: {
              required: 'This field is required',
            },
            metaData: {
              optionsKey: 'docProof',
            },
            ui: {
              grid: {
                xs: 12,
                md: 6,
                lg: 4,
              },
            },
          },
        ],
      },
      {
        sectionId: 'awards',
        sectionName: 'Statement of Purpose',
        subSectionName: '',
        sectionPosition: 6,
        sectionType: 'form',
        fields: [
          {
            fieldId: 'application[Statement_of_Purpose__c]',
            name: 'application[Statement_of_Purpose__c]',
            label: 'Statement of Purpose',
            type: 'input',
            multiline: true,
            required: true,
            rows: 4,
            validations: {
              required: 'This field is required',
              maxLength: {
                value: 500,
                message: 'This field cannot be greater than 500 characters',
              },
            },
            remaining: true,
            maxCharacters: 500,
            ui: {
              grid: {
                xs: 12,
                md: 12,
                lg: 12,
              },
            },
          },
        ],
      },
    ],
  },
  {
    "stepId": "documentUpload",
    "stepName": "Document Uploads",
    "showStepName": false,
    "stepVisible": true,
    "stepPosition": 1,
    "stepType": "documentUpload",
    "sections": [
      {
        "sectionId": "documentUpload",
        "sectionName": "Document Upload",
        "subSectionName": "",
        "sectionPosition": 6,
        "sectionType": "form",
        "fields": []
      }
    ]
  },
  {
    "stepId": "summaryWithDeclaration",
    "stepName": "Summary",
    "stepPosition": 5,
    "showStepName": true,
    "stepVisible": true,
    "stepType": "summary",
    "voucher": true,
    "sections": []
  },
  {
    stepId: 'declaration',
    stepName: 'Payment & Declaration',
    stepPosition: 5,
    showStepName: true,
    stepVisible: true,
    stepType: 'declaration',
    voucher: true,
    sections: [],
  },
];
